import { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || '';

const EVENTS = {
  WI: {
    label: 'Wisconsin', dates: 'August 21–22, 2026',
    location: 'Camp Whitcomb/Mason, Hartland, WI',
    days: ['Friday, August 21st', 'Saturday, August 22nd'],
    activities: ['Water Skiing','Wakeboarding','Tubing','Pontoon Boat Rides','Kayaking','Fishing','Swimming','Hayrides','Adaptive Rock Climbing','Interactive Drum Circle','Adaptive Pool Snorkeling','Yard Games','Art/Craft Station','Dunk Tank','Pet Therapy','Action Track Chair'],
    schedule: [
      { time: '8:45 AM', item: 'Athlete Arrivals & Registration' },
      { time: '8:55 AM', item: 'Event Welcome & Announcements' },
      { time: '9:00 AM', item: 'Activities Start' },
      { time: '12:00–1:00 PM', item: 'Lunch — All activities pause' },
      { time: '1:00–4:00 PM', item: 'Afternoon Activities Resume' },
      { time: '4:00 PM', item: 'Event Ends' },
    ],
    volunteerRoles: {
      'On Land': ['Parking/Road Assistant','Golf Cart Shuttle Driver','Registration Assistants','Event Ambassador Assistant','Food & Beverage Coordinator','Food Tent Assistants','Snack Runner','Adaptive Climbing Team','Drum Circle Team','Track Chair Assistants','Hayride Assistants','Dunk Tank Lead','Dunk Tank Dunkee','Athlete Transfer Specialist – LAND','Shoreline Fishing & Touch Tank Assistants','Yard Games & Bouncy House Assistant','Art/Craft Assistant','Pet Therapy','Shoreline Kayak Lead','Athlete Transfer Specialist – SHORELINE (Kayak)','Sports Equipment Specialists','Shoreline Photographer','Drone Videographers','Athlete Buddy','Athlete Schedule Assistant/Wrangler','Ski Buddy','Ski Staging Assistant','Ski/Tube/Toon Queue Controller','Pool Snorkeling Instructor','Pool Snorkeling Buddy','Pool Snorkeling Assistant – Pool Deck'],
      'In/On the Water': ['Swimming Attendees/Beach Retrievers','Kayak Assistants','Pool Snorkeling Assistant – Water','Athlete Tube Partners','Side Skiers','Jet Ski Drivers','Jet Ski Jumpers','Dock/Water Clinical Specialist/Lead','Athlete Transfer Specialist – DOCK/WATER','Tow Boat Photographers/Videographers','Tow Boat Drivers','Tow Boat Quick Release/Spotters'],
      'On the Dock': ['Dock Boss Assistant','Pontoon Dock Assistant','Dock Traffic/Ski Queue Controller','Observation Boat Assistant','Bay Spotter Boat','Pontoon Boat Tour Drivers','Pontoon Boat Assistants'],
    },
  },
  MI: {
    label: 'Michigan', dates: 'July 23–24, 2026',
    location: 'Action Water Sports, Hudsonville, MI',
    days: ['Thursday, July 23rd', 'Friday, July 24th'],
    activities: ['Adaptive Cable Water Skiing','Aqua Park','Shoreline Fishing','Jet Ski Rides','ACT Creative Cube Crafts','Kayaking','Paddleboarding','Waterslide','Swimming'],
    schedule: [
      { time: '8:45 AM', item: 'Athlete Arrivals & Registration' },
      { time: '8:55 AM', item: 'Event Welcome & Announcements' },
      { time: '9:00 AM', item: 'Activities Start' },
      { time: '12:00–1:00 PM', item: 'Lunch — All activities pause' },
      { time: '1:00–3:00 PM', item: 'Afternoon Activities Resume' },
      { time: '3:00 PM', item: 'Event Ends' },
    ],
    volunteerRoles: {
      'Off the Water': ['Parking/Road Assistants','Golf Cart Shuttle Driver','Registration Coordinator','Registration Assistants','Sport Coordinator/Athlete Scheduler','Food Tent Assistants','Food & Beverage Coordinator','Track Chair Assistants','Athlete Transfer Specialist – LAND','Shoreline Fishing Assistants','Creative Cube Art Assistant','Shoreline Clinical Specialist (Kayak)','Athlete Transfer Specialist – SHORELINE (Kayak)','Sports Equipment Specialists','Photographer','Drone Videographers','Athlete Buddy','Ski-Staging Assistant'],
      'In/On the Water': ['Swimming Attendees/Beach Retrievers','Kayak Assistants','Paddleboard Assistants','Cable Ski Exit – Swimmer/Retriever','Cable Ski Exit – Tube Holder','Cable Ski Exit – Ski Lifter','Athlete Transfer Specialist – Cable Skier Shoreline Retriever','Athlete Transfer Specialist – Shoreline','Aqua Park Tube Taxi – Jet Ski Driver','Cable Park Tube Taxi – Jet Ski Driver','Dock/Water Clinical Specialist/Lead','On Water Safety Jumper'],
      'On the Dock': ['Cable Dock Boss','Cable Dock Boss Assistant','Cable Dock Traffic Controller','Aqua Park Boss','Aqua Park Attendant'],
    },
  },
};

const WI_ROLE_DESCRIPTIONS = {
  'Parking/Road Assistant': 'Communicate/direct vehicles to/from the shoreline. Will make sure all cars are parked properly in an orderly manner up by the lodge parking area. Will notify Golf Cart/Shuttle Drivers with pick up/drop off needs. Arrive 15 min before volunteer start time (7:45am). Bring a comfy lawn chair and a good book or activity to keep self-busy when traffic flow is low.',
  'Golf Cart Shuttle Driver': 'Will travel between parking lot, shoreline and pool to shuttle guests and volunteers to and from their vehicles. Arrive 15 min before volunteer start time (7:45am). Must be 16 or older to drive a golf cart.',
  'Registration Assistants': 'Will check in/out guests and volunteers. Assist with making sure all waivers are signed and collected. Hand off to Event Ambassador/Asst. once athlete/guests registered.',
  'Event Ambassador Assistant': 'Receives handoff from registration. Will greet guests with the Event Ambassador after registration, review daily schedule & activities/event options with athlete and guest. Thank athlete and guest upon departure, obtains feedback on event, highlights donors and sponsors, and will notify Golf Cart/Shuttle Drivers with pick up needs for guests & volunteers parked in upper lot.',
  'Food & Beverage Coordinator': 'Will coordinate lunch & snack organization and logistics and guide/oversee Food Tent Assistants.',
  'Food Tent Assistants': 'Assist with tent set up and lunch set up and prep needs, serves lunch session, manage snacks, beverages and ice. Runner to/from dock/boat volunteer teams for snacks and drinks as needed. Oversee Inclusion Coffee volunteers.',
  'Snack Runner': 'Provides water and snacks to athletes and guests throughout the day. Clean up garbage on pier and stationary pontoon.',
  'Adaptive Climbing Team': 'Must be certified and pre-approved for this position (per Sam S - Adaptive Climbing Coordinator) before registering.',
  'Drum Circle Team': 'Setting up, organizing, and running the drumming circle.',
  'Track Chair Assistants': 'Provide athlete guided tours/use of action track chair. Assures safety guidelines followed and assist in comfort adjustments of the rider. Must be knowledgeable in operating an Action Trackchair.',
  'Hayride Assistants': 'Assist with athlete & guest transfers in/out of hay ride; assist with safety and supervision during the hayride.',
  'Dunk Tank Lead': 'Oversees the dunk tank activity and safety of the dunkees in the tank. Assists athletes and guests with engaging in activity and assisting with ball throwing and fun!',
  'Athlete Transfer Specialist – LAND': 'Assist with athlete & guest transfers in/out of hay ride; Assist with athlete transfers in/out of track chair. May require heavy lifting.',
  'Shoreline Fishing & Touch Tank Assistants': 'Perfect for true fishing and aquatic animal lovers. Coordinating shoreline fishing, aid in baiting the hooks, casting and reeling, and catch/release of fish. Monitor aquatic critters/fish in tank.',
  'Yard Games & Bouncy House Assistant': 'Engages in different yard games with athletes and guests.',
  'Art/Craft Assistant': 'Engages athletes and guests in the art/craft station & assists athletes and guests with crafting projects.',
  'Pet Therapy': 'Must have Service to Assistance Dog Certification and active Member ID (provide copy to Event Coordinator).',
  'Shoreline Kayak Lead': 'Assesses and determines optimal kayak option, fit and positioning for each athlete. Partners with kayak team to prepare equipment for each athlete, assures safe transfers and water safety. May need to stay with athletes during kayak activity on water. Land & Water Role. Strong kayak skills and Physical Therapist preferred.',
  'Athlete Transfer Specialist – SHORELINE (Kayak)': 'Assist with athlete transfers in/out of kayak. Partners with Kayak Lead to prepare equipment for each athlete. May require heavy lifting.',
  'Sports Equipment Specialists': 'Fits and adjusts ski equipment for each athlete before each ski/water event. Will help load athlete onto equipment at the dock as needed. Ensure all equipment is returned to inventory. Requires knowledge in adaptive ski equipment, fitting, and positioning.',
  'Shoreline Photographer': 'Take photos of athletes, guests, volunteers, and the camp to capture magical moments during the events. If you have a camera or GoPro to lend, please indicate in comments.',
  'Drone Videographers': 'Uses a drone to take video of athletes, guests, volunteers, and the camp to capture magical moments during the events. If you have a camera or GoPro to lend, please indicate in comments.',
  'Athlete Buddy': 'Oversees a cohort of athletes. Coordinates with the Sports Coordinator on athletes water sport schedules. Hands off to Ski Buddy for SKI, TUBE, TOON activities. Assist athletes and help caregivers with changing, toileting, meal assistance, transfers, etc. Partners with Event & Athlete Ambassador to assure athlete enjoys all activities. Requires a lot of interaction with athletes, guests and other volunteer roles. A lot of movement/running around event site.',
  'Ski Buddy': 'Oversees the cohort of athletes and guests once on deck for ski/tube/toon (hand off from/to Athlete Buddy). Communicates with athlete and family while in queue. Communicates with Ski Scheduler when athlete is in shore prep, leaves ski phase/area, or returns to ski/tube line.',
  'Ski Staging Assistant': 'Helping athletes with getting life jackets on; making sure it\'s properly fit/positioned when on deck for a water activity.',
  'Athlete Schedule Assistant/Wrangler': 'Coordinates with Sports Coordinator on athlete water sport schedules. Communicates athlete status to staging area.',
  'Pool Snorkeling Instructor': 'Must be certified Instructor and pre-approved for this position before registering. Provides snorkel supplies, prepares all equipment and teaches/assists athletes with snorkel activity. Tears down and cleans all supplies.',
  'Pool Snorkeling Buddy': 'Receives handoff from Athlete Buddies at the shore and oversees the cohort of athletes during pool snorkeling activity. Will travel between pool and shoreline with athletes and caregivers. This is a limited time commitment (up to 2 hours).',
  'Pool Snorkeling Assistant – Pool Deck': 'Monitor capacity of snorkelers/caregivers in pool, track stats. Help get snorkelers ready for water activities; getting life jackets on and properly fit. Assist PADI Instructor with preparing and cleaning up all snorkeling equipment. Limited time commitment (up to 2 hours).',
  'Pool Snorkeling Assistant – Water': 'Aid in monitoring snorkelers and caregivers in the pool and helping them in/out of the water. Must be a strong swimmer. Lifting may be involved. Limited time commitment (up to 2 hours).',
  'Dunk Tank Dunkee': 'Get dunked! Entertain athletes while in tank. Good tween volunteer role — must be a good swimmer and able to be in cold water for long periods. Will alternate intermittently with a land position to warm up.',
  'Swimming Attendees/Beach Retrievers': 'Aid in monitoring swimmers at the beach and helping them in/out of the water. In the event of a beach launch, will move the ski/tube and skier/tuber into the water and double check life vest fit. Will assist with water starts and make adjustments to equipment. In the event of a beach retrieval, will swim with the tow rope to meet skiers and assist getting the athlete back to shore.',
  'Kayak Assistants': 'Aid in transferring athletes in/out of kayak, kayak the athlete or assist them/stay with them throughout the kayak activity.',
  'Pontoon Boat Tour Drivers': 'Will drive the pontoon boat at a safe distance from other boats on the outer edge of the ski loop. Must work directly with the main dock team to secure the boat for loading/offloading. Must have pontoon boat driving experience.',
  'Pontoon Boat Assistants': 'Assist the Pontoon Dock Assistant with launching and docking of pontoons. Monitor safety and provide supervision of athletes and guests at all times during the ride. Socialize with guests while on the boat.',
  'Observation Boat Assistant': 'Assist athletes and guests on/off pier and on/off the stationary pontoon observation boat at the shoreline for viewing skiers/tubers. Monitor safety and provide supervision at all times. Socialize with guests while on the boat.',
  'Bay Spotter Boat': 'Monitor and redirect any nuisance activity in the bay during skiers run. Notifies Event/Volunteer Coordinators of any concerning activity. Lake Keesus Resident or knowledge of Lake Keesus and experienced pontoon boat driver required.',
  'Athlete Tube Partners': 'Assists athletes into/out of the tube and stays with them the entire tube run. If a fall occurs, must be capable of assisting athlete to the tow boat. Must be a strong swimmer; Current or previous certified lifeguard experience required. Must complete safety video prior to the event.',
  'Side Skiers': 'Assist with the entire ski run. Must be capable of skiing with two skis for at least 2 laps around North Bay while holding up sit ski with adaptive athlete. Must also ski with one arm. If athlete falls, skier falls with the athlete and assists with reloading. Badgerland Ski Team member or previous water ski team experience required. Must be a strong skier and swimmer.',
  'Tow Boat Photographers/Videographers': 'Take photos & video footage of athletes, guests, volunteers, and the camp from the towboats. If you have a camera or GoPro to lend, please indicate in comments.',
  'Tow Boat Drivers': 'Must have boat driving and towing experience. Ensure the boat has the appropriate number of life vests on board. Badgerland Members Only.',
  'Tow Boat Quick Release/Spotters': 'Reinforces verbal commands, hand signals, and ski plan with the athlete and water assistants. Watches and anticipates falls to release the tow rope at the right moment. Acts as co-captain to the boat driver. Will enter water in an emergency. Must be on Badgerland Ski Team or have previous pinning experience. Badgerland Members Only.',
  'Jet Ski Drivers': 'Driver will flank athletes at a safe distance at all times. Must have previous jet ski driving experience.',
  'Jet Ski Jumpers': 'Will enter water to help athletes and side skiers in the event of a fall. Must be a strong swimmer; must have current or previous certified lifeguard experience. Must complete safety video prior to the event.',
  'Dock/Water Clinical Specialist/Lead': 'Water and safety lead/training for transferring and positioning athletes in/out of water for water sport (ski/tubing). Must have experience in adaptive water sport equipment, transferring and positioning.',
  'Athlete Transfer Specialist – DOCK/WATER': 'Assist with athlete transfers in/out of water from dock. May require heavy lifting. In water a LOT.',
  'Dock Boss Assistant': 'Will assist with the docking of the tow boats and help launch the tow boat for each run as well as helping manage the ropes. Must be Badgerland Ski Team member or previous Ski team experience.',
  'Pontoon Dock Assistant': 'Will assist with launching and docking pontoons; assist with athlete and guest safety on the dock and when departing and returning from pontoon rides.',
  'Dock Traffic/Ski Queue Controller': 'Preparing the next skier/tubers in line. Conduit between Ski/Tube Queue Controller and Ski Buddy. Control who goes on/off pier. Socializes with athletes and guests. Police entrance to the pier at all times.',
};


const SHIRT_SIZES = ['Youth XS','Youth S','Youth M','Youth L','XS','S','M','L','XL','XXL','XXXL'];

const MI_ROLE_DESCRIPTIONS = {
  'Golf Cart Shuttle Driver': 'Will travel between parking lot and shoreline to shuttle guests and volunteers to and from their vehicles. Arrive 15 min before volunteer start time (7:45am).',
  'Registration Coordinator': 'Coordinate with Anthros Foundation and At the Lake event leads on event planning, leads website design and online registration build for volunteers and athletes, manages all online communication push notifications. Oversees check in/out process/workflow and registration assistants.',
  'Registration Assistants': 'Will check in/out guests and volunteers as well as be responsible for the volunteer waivers, attendee waivers, and photo release waivers are all signed and collected. Hand off to Guest Ambassador once athlete/guests registered.',
  'Sport Coordinator/Athlete Scheduler': 'Manages athlete scheduling & logistics for boating activities/events. Receives athlete interest/intake from Guest Ambassador. Communicates with Ski Buddies when athlete on deck for event slot.',
  'Food Tent Assistants': 'Assist with tent set up and lunch set up and prep needs, serves lunch session, manage snacks, beverages and ice. Runner to/from dock/boat volunteer teams for snacks and drinks as needed.',
  'Food & Beverage Coordinator': 'Will coordinate lunch & snack organization and logistics and guide/oversee Food Tent Assistants.',
  'Track Chair Assistants': 'Provide athlete guided tours/use of action track chair. Assures safety guidelines followed and assist in comfort adjustments of the rider. Must be knowledgeable in operating an Action Track chair.',
  'Athlete Transfer Specialist – LAND': 'Assist with athlete & guest transfers in/out of hayride; Assist with athlete transfers in/out of track chair. May require heavy lifting.',
  'Shoreline Fishing Assistants': 'Perfect for true fishing lovers. Coordinating shoreline fishing, aid in baiting the hooks, casting, and reeling, and catch/release of fish.',
  'Creative Cube Art Assistant': 'Assists Creative Cube Coordinator with any Creative Cube art/craft activities.',
  'Shoreline Clinical Specialist (Kayak)': 'Assesses and determines optimal kayak option, fit and positioning for each athlete. Partners with Shoreline Team Lead to prepare the equipment for each athlete, assures safe transfers and water safety.',
  'Athlete Transfer Specialist – SHORELINE (Kayak)': 'Assist with athlete transfers in/out of kayak. May require heavy lifting. Partners with Shoreline Clinical Specialist to prepare the equipment for each athlete.',
  'Sports Equipment Specialists': 'Fits and adjusts ski equipment for each athlete before each ski/water event. Will help load athlete onto equipment at the dock as needed. Ensure all equipment is returned to inventory. Requires knowledge in adaptive ski equipment, fitting, and positioning.',
  'Photographer': 'Take photos of athletes, guests, volunteers, and the camp to capture magical moments during the events.',
  'Drone Videographers': 'Uses a drone to take video of athletes, guests, volunteers, and the camp to capture magical moments during the events.',
  'Athlete Buddy': 'Oversees a cohort of athletes. Coordinates with the Sports Coordinator on athletes water sport schedules. When athlete is on deck, brings athlete to staging area to meet with Sports Equipment Specialists. Partners with Guest Ambassador to assure athlete enjoys all activities available.',
  'Ski-Staging Assistant': 'Helping get athletes ready for water activities; getting life jackets on; making sure it\'s properly fit/positioned.',
  'Swimming Attendees/Beach Retrievers': 'Will aid in monitoring swimmers at the beach and helping them in and out of the water. In the event of a beach launch, will move the ski/tube and the skier/tuber into the water and double check the fit of life vests and gear.',
  'Kayak Assistants': 'Aid in transferring athletes in/out of kayak and assist them/stay with them throughout the kayak activity.',
  'Paddleboard Assistants': 'Aid in transferring athletes on/off of paddleboard and assist them/stay with them throughout the paddleboard activity.',
  'Cable Ski Exit – Swimmer/Retriever': 'Will aid in monitoring and retrieving athletes in the water as the athlete passes by on the cable board water activity. Must be a strong swimmer.',
  'Cable Ski Exit – Tube Holder': 'Will aid in holding tube at ski exit area while athlete is being transferred to tube.',
  'Cable Ski Exit – Ski Lifter': 'Will aid in lifting athlete in ski onto tube to transit back to launch area. Requires heavy lifting.',
  'Athlete Transfer Specialist – Cable Skier Shoreline Retriever': 'Will aid in transferring athlete from cable ski to tube and preparing tube to take back to boat launch.',
  'Athlete Transfer Specialist – Shoreline': 'Will aid in transferring athlete from the water tube to the athlete\'s chair (if required) or to the shoreline.',
  'Aqua Park Tube Taxi – Jet Ski Driver': 'Driver of Jet Ski who will assist with jet ski rides or with transferring equipment back to launch area.',
  'Cable Park Tube Taxi – Jet Ski Driver': 'Driver of Jet Ski who will assist with cable park tube taxi operations.',
  'Dock/Water Clinical Specialist/Lead': 'Water and safety lead/training for transferring and positioning athletes in/out of water for water sport (ski/tubing). Must have experience in adaptive water sport equipment, transferring and positioning.',
  'On Water Safety Jumper': 'Will enter water to help athletes in the event of a fall and at the end point of the ski run. Will assist athlete to the shoreline so they can be transported back to the exit point.',
  'Cable Dock Boss': 'Coordinates and leads communication with water and cable park controller teams. Oversees dock team members, coordinates with the Sports Coordinator and Dock Traffic Controller. Maintains athlete safety on the dock.',
  'Cable Dock Boss Assistant': 'Will assist the Cable Dock Boss as needed and help prepare athletes for ski activities.',
  'Cable Dock Traffic Controller': 'Manage traffic on and off the dock, receive athletes from the staging area with prepared equipment and properly fitted life jacket. Coordinates timing with Water Coordinator and oversees safety.',
  'Aqua Park Boss': 'Works with Action Wake Staff and helps to manage athletes entering and exiting Aqua Park. Will ensure all athletes are entering and exiting course safely.',
  'Aqua Park Attendant': 'Will monitor and aid athletes as they are participating in the Aqua Park.',
  'Parking/Road Assistants': 'Direct and assist vehicles in the parking area, ensuring safe and organized parking for all event guests and volunteers.',
};

const DIETARY = ['None','Vegetarian','Vegan','Gluten-Free','Nut Allergy','Dairy-Free','Halal','Kosher','Other'];

const WAIVER = `LIABILITY WAIVER AND RELEASE OF LIABILITY

PLEASE READ THIS DOCUMENT CAREFULLY BEFORE SIGNING.

By registering for and participating in the Anthros Foundation "At The Lake" event ("Event"), you agree to the following terms and conditions:

1. ASSUMPTION OF RISK: I understand and acknowledge that participation in the Event, including but not limited to water skiing, kayaking, tubing, swimming, and all other activities, involves inherent risks, dangers, and hazards including serious injury or death. I voluntarily assume all risks associated with participation in the Event.

2. RELEASE OF LIABILITY: I hereby release, waive, discharge, and covenant not to sue the Anthros Foundation, its officers, directors, employees, volunteers, sponsors, and affiliates from any and all claims, demands, losses, damages, costs, or expenses arising out of or in connection with my participation in the Event.

3. MEDICAL AUTHORIZATION: I hereby authorize the Anthros Foundation and its representatives to obtain emergency medical treatment on my behalf should it be deemed necessary.

4. GOVERNING LAW: This agreement shall be governed by the laws of the State of Wisconsin.

[PLACEHOLDER – Replace with official Anthros Foundation legal waiver language before go-live]`;

const PHOTO_RELEASE = `ANTHROS FOUNDATION PHOTO / MEDIA RELEASE

By participating in this event, I (or my child/dependent, if under 18) grant permission to Anthros Foundation and its representatives to take photographs and/or video recordings. I understand these images may be used in promotional materials, such as brochures, social media, websites, and press releases. I waive any rights to review or compensation related to their use.

Note: If you do not agree, please remind us at registration — we will provide a different color wristband to remind volunteers of your no-photo preference.`;

const COMM_CONSENT = `COMMUNICATIONS CONSENT

Anthros is committed to protecting and respecting your privacy, and we'll only use your personal information to administer your account and to provide the products and services you requested from us.

From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. You can unsubscribe at any time.

For more information, please review our Privacy Policy at anthros.com/privacy-policy.`;

// ─── Styles ────────────────────────────────────────────────────────────────
const s = {
  app: { fontFamily: "'Segoe UI',sans-serif", minHeight: '100vh', background: '#f5f5f5', color: '#1a1a1a' },
  header: { background: '#1a1a1a', padding: '12px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100 },
  logo: { fontWeight: 800, fontSize: 20, letterSpacing: 1, color: '#4fc3c3' },
  logoSub: { fontSize: 10, color: '#aaa', letterSpacing: 3, textTransform: 'uppercase', marginTop: 2 },
  nav: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  navBtn: a => ({ padding: '7px 14px', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13, background: a ? '#4fc3c3' : 'transparent', color: a ? '#1a1a1a' : '#ccc' }),
  page: { maxWidth: 960, margin: '0 auto', padding: '28px 16px' },
  card: { background: '#fff', borderRadius: 10, padding: 24, marginBottom: 20, boxShadow: '0 1px 4px rgba(0,0,0,.08)' },
  h2: { fontSize: 22, fontWeight: 700, margin: '0 0 16px' },
  h3: { fontSize: 15, fontWeight: 700, margin: '16px 0 8px', color: '#333' },
  label: { display: 'block', fontWeight: 600, fontSize: 13, marginBottom: 5, color: '#333' },
  input: { width: '100%', padding: '9px 12px', border: '1.5px solid #ddd', borderRadius: 7, fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit', outline: 'none' },
  select: { width: '100%', padding: '9px 12px', border: '1.5px solid #ddd', borderRadius: 7, fontSize: 14, boxSizing: 'border-box', background: '#fff', fontFamily: 'inherit' },
  textarea: { width: '100%', padding: '9px 12px', border: '1.5px solid #ddd', borderRadius: 7, fontSize: 14, boxSizing: 'border-box', minHeight: 80, resize: 'vertical', fontFamily: 'inherit' },
  btnPrimary: { background: '#4fc3c3', color: '#1a1a1a', border: 'none', borderRadius: 7, padding: '11px 24px', fontWeight: 700, fontSize: 15, cursor: 'pointer' },
  btnSecondary: { background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: 7, padding: '9px 18px', fontWeight: 600, fontSize: 14, cursor: 'pointer' },
  btnBack: { background: 'transparent', color: '#666', border: '1.5px solid #ddd', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer', marginBottom: 20 },
  btnSmall: { background: '#4fc3c3', color: '#1a1a1a', border: 'none', borderRadius: 5, padding: '5px 12px', fontWeight: 600, fontSize: 12, cursor: 'pointer' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16 },
  field: { marginBottom: 16 },
  steps: { display: 'flex', marginBottom: 28, borderRadius: 8, overflow: 'hidden', border: '1.5px solid #eee' },
  step: st => ({ flex: 1, padding: '10px 4px', textAlign: 'center', fontSize: 12, fontWeight: 700, background: st === 'active' ? '#4fc3c3' : st === 'done' ? '#1a1a1a' : '#f5f5f5', color: st === 'active' ? '#1a1a1a' : st === 'done' ? '#4fc3c3' : '#999', cursor: st === 'done' ? 'pointer' : 'default' }),
  waiverBox: { background: '#f9f9f9', border: '1.5px solid #ddd', borderRadius: 7, padding: 16, maxHeight: 160, overflowY: 'auto', fontSize: 12, lineHeight: 1.6, marginBottom: 10, whiteSpace: 'pre-wrap' },
  checkRow: { display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 },
  divider: { borderTop: '1.5px solid #eee', margin: '20px 0' },
  badge: c => ({ background: c, color: '#fff', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700 }),
  tag: (bg) => ({ display: 'inline-block', background: bg || '#e8f9f9', borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 600, marginRight: 4 }),
  alert: t => ({ background: t === 'success' ? '#e8f9f9' : '#fdecea', border: `1.5px solid ${t === 'success' ? '#4fc3c3' : '#e74c3c'}`, borderRadius: 7, padding: '12px 16px', marginBottom: 16, fontSize: 14 }),
  eventCard: { border: '2px solid #4fc3c3', borderRadius: 10, padding: 24, cursor: 'pointer', background: '#f9fffe' },
  statCard: { background: '#fff', borderRadius: 10, padding: 20, textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,.08)' },
  th: { background: '#1a1a1a', color: '#fff', padding: '6px 8px', textAlign: 'left', fontWeight: 600, fontSize: 12 },
td: { padding: '10px 8px', borderBottom: '1px solid #eee', verticalAlign: 'top', fontSize: 12 },
  wakeParkBox: { background: '#fff8e1', border: '2px solid #f0c040', borderRadius: 8, padding: 20, marginBottom: 16 },
  filterTh: { background: '#f9f9f9', padding: '8px 10px' },
filterInput: { width: '100%', padding: '6px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 12, boxSizing: 'border-box', height: 32 },
};

// ─── Helpers ───────────────────────────────────────────────────────────────
const F = ({ label, req, children }) => (
  <div style={s.field}>
    <label style={s.label}>{label}{req && <span style={{ color: '#e74c3c' }}> *</span>}</label>
    {children}
  </div>
);
const Inp = p => <input style={s.input} {...p} />;
const Sel = ({ opts, ...p }) => (
  <select style={s.select} {...p}>
    <option value="">— Select —</option>
    {opts.map(o => <option key={o}>{o}</option>)}
  </select>
);
const CheckList = ({ opts, selected, onChange, cols = 2 }) => (
  <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols},1fr)`, gap: 6 }}>
    {opts.map(o => (
      <label key={o} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
        <input type="checkbox" checked={selected.includes(o)}
          onChange={() => onChange(selected.includes(o) ? selected.filter(x => x !== o) : [...selected, o])} />
        {o}
      </label>
    ))}
  </div>
);
const SHORT_DAY = {
  'Friday, August 21st': 'Fri 8/21',
  'Saturday, August 22nd': 'Sat 8/22',
  'Thursday, July 23rd': 'Thu 7/23',
  'Friday, July 24th': 'Fri 7/24',
};
const shortDays = (days) => (days || []).map(d => SHORT_DAY[d] || d).join(', ');
function renderEmailPreviewHtml(rawBody) {
  let body = rawBody || '';
  let buttonHtml = '';
  const btnMatch = body.match(/\[REGISTER_BUTTON:(.*?)\]/);
  if (btnMatch) {
    buttonHtml = `<div style="text-align:center;margin:20px 0;"><span style="display:inline-block;background:#4fc3c3;color:#1a1a1a;padding:12px 28px;border-radius:50px;font-weight:700;font-size:14px;">Register Now →</span></div>`;
    body = body.replace(/\[REGISTER_BUTTON:.*?\]/, '').trim();
  }

  const inlineFormat = (text) => {
    let out = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    out = out.replace(/(https?:\/\/[^\s<]+)/g, url => `<span style="color:#2980b9;text-decoration:underline;">${url}</span>`);
    out = out.replace(/\{\{firstName\}\}/g, 'Friend');
    return out;
  };

  const lines = body.split('\n').map(l => l.trim());
  let html = '';
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (line === '') { i++; continue; }
    if (line === '---') { html += `<hr style="border:none;border-top:1.5px solid #eee;margin:16px 0;" />`; i++; continue; }
    if (line.startsWith('## ')) {
      html += `<p style="margin:14px 0 6px;color:#1a1a1a;font-size:15px;font-weight:700;">${inlineFormat(line.slice(3))}</p>`;
      i++; continue;
    }
    if (line.startsWith('- ')) {
      let group = [];
      while (i < lines.length && lines[i].startsWith('- ')) { group.push(lines[i].slice(2)); i++; }
      html += `<ul style="margin:0 0 12px;padding-left:20px;">${group.map(item => `<li style="color:#333;font-size:13px;line-height:1.7;">${inlineFormat(item)}</li>`).join('')}</ul>`;
      continue;
    }
    html += `<p style="margin:0 0 10px;color:#333;font-size:13px;line-height:1.6;">${inlineFormat(line)}</p>`;
    i++;
  }
  return html + buttonHtml;
}
function RoleCheckList({ opts, selected, onChange, descriptions = {} }) {
  const [tooltip, setTooltip] = useState({ visible: false, text: '', x: 0, y: 0 });

  const showTip = (e, text) => {
    if (!text) return;
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltip({ visible: true, text, x: rect.left, y: rect.bottom + window.scrollY + 6 });
  };
  const hideTip = () => setTooltip(t => ({ ...t, visible: false }));

  return (
    <>
      {tooltip.visible && (
        <div style={{
          position: 'absolute', zIndex: 1000,
          left: Math.min(tooltip.x, window.innerWidth - 320),
          top: tooltip.y,
          background: '#1a1a1a', color: '#fff',
          padding: '10px 14px', borderRadius: 8,
          fontSize: 12, lineHeight: 1.6,
          maxWidth: 300, boxShadow: '0 4px 16px rgba(0,0,0,.3)',
          pointerEvents: 'none',
        }}>
          {tooltip.text}
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 6 }}>
        {opts.map(o => {
          const hasDesc = !!descriptions[o];
          return (
            <label key={o} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer', padding: '3px 0' }}
              onMouseEnter={e => showTip(e, descriptions[o])}
              onMouseLeave={hideTip}>
              <input type="checkbox" checked={selected.includes(o)}
                onChange={() => onChange(selected.includes(o) ? selected.filter(x => x !== o) : [...selected, o])} />
              <span>{o}</span>
              {hasDesc && (
                <span style={{ marginLeft: 2, color: '#4fc3c3', fontSize: 14, fontWeight: 700, cursor: 'help' }}
                  title={descriptions[o]}>ⓘ</span>
              )}
            </label>
          );
        })}
      </div>
    </>
  );
}

// ─── Home ──────────────────────────────────────────────────────────────────
function Home({ go }) {
  return (
    <div style={s.page}>
      {/* Hero */}
      <div style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 24, position: 'relative', minHeight: 420, backgroundImage: 'url(/hero-bg.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.52)' }} />

        {/* MI event — upper left */}
        <div style={{ position: 'absolute', top: 20, left: 20, zIndex: 3, textAlign: 'left' }}>
          <div style={{ fontWeight: 800, fontSize: 16, color: '#4fc3c3' }}>ATL – Michigan</div>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#fff', marginTop: 2 }}>July 23–24, 2026</div>
          <div className="desktop-only" style={{ fontWeight: 700, fontSize: 12, color: '#fff', marginTop: 1 }}>Action Water Sports, Hudsonville, MI</div>
        </div>

        {/* WI event — upper right */}
        <div style={{ position: 'absolute', top: 20, right: 20, zIndex: 3, textAlign: 'right' }}>
          <div style={{ fontWeight: 800, fontSize: 16, color: '#4fc3c3' }}>ATL – Wisconsin</div>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#fff', marginTop: 2 }}>August 21–22, 2026</div>
          <div className="desktop-only" style={{ fontWeight: 700, fontSize: 12, color: '#fff', marginTop: 1 }}>Camp Whitcomb/Mason, Hartland, WI</div>
        </div>

        {/* Center content */}
        <div style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 420, padding: '20px 24px 40px' }}>
          {/* Actual ATL logo — inverted to white */}
          <img
            src="/AtTheLakeLogo_black copy.png"
            alt="At The Lake"
            style={{ width: 220, marginBottom: 32, filter: 'invert(1) brightness(2)', marginTop: -60 }}
          />

          {/* Registration buttons */}
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button style={{ ...s.btnPrimary, fontSize: 16, padding: '13px 28px' }} onClick={() => go('athlete-select')}>🏄 Register as Athlete</button>
            <button style={{ background: '#fff', color: '#000', border: 'none', borderRadius: 7, padding: '13px 28px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }} onClick={() => go('volunteer-select')}>🙌 Register as Volunteer</button>
            <button style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: '2px solid rgba(255,255,255,0.5)', borderRadius: 7, padding: '13px 24px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }} onClick={() => go('group-select')}>👥 Day Group Registration</button>
            <button style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: '2px solid rgba(255,255,255,0.5)', borderRadius: 7, padding: '13px 24px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }} onClick={() => go('waitlist-select')}>📋 Join Waitlist</button>
          </div>
        </div>
      </div>

      {/* Welcome message */}
      <div style={{ ...s.card, textAlign: 'center', maxWidth: 760, margin: '0 auto 20px', background: 'rgba(79,195,195,0.12)', border: '1px solid rgba(79,195,195,0.25)' }}>
        <p style={{ fontSize: 15, lineHeight: 1.8, color: '#333', marginBottom: 14 }}>
          <a href="https://anthrosfoundation.org" target="_blank" rel="noreferrer" style={{ color: '#1a1a1a', fontWeight: 700, textDecoration: 'underline' }}>Anthros Foundation</a> At The Lake signature event is more than just a day on the water — it's a celebration of ability, inclusion, community, and unforgettable memories. We are so excited to welcome you and your family to this special event and can't wait to spend the day together At The Lake!
        </p>
        <p style={{ fontSize: 15, lineHeight: 1.8, color: '#333', marginBottom: 14 }}>
          Created for individuals with disabilities or special needs, At The Lake provides an opportunity to experience the joy, freedom, and excitement of lake life in a safe, supportive, and encouraging environment. From adaptive waterskiing and tubing to kayaking, paddleboarding, swimming, fishing, and more, every activity is tailored to each athlete's abilities and supported by caring volunteers, instructors, and families.
        </p>
        <p style={{ fontSize: 15, lineHeight: 1.8, color: '#333', marginBottom: 14 }}>
          Our mission is simple: to create smiles, build confidence, encourage connection, and give every athlete multiple opportunities throughout the day to try new things, challenge themselves, and most importantly — have an amazing time surrounded by people who are cheering them on every step of the way.
        </p>
        <p style={{ fontSize: 15, lineHeight: 1.8, color: '#333' }}>
          We are truly honored to have you join us and look forward to creating lasting memories together At The Lake!
        </p>
      </div>

  {/* Register CTA */}
<div style={{ textAlign: 'center', marginBottom: 20 }}>
  <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
    <button style={{ ...s.btnPrimary, fontSize: 16, padding: '13px 28px' }} onClick={() => go('athlete-select')}>🏄 Register as Athlete</button>
    <button style={{ background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: 7, padding: '13px 28px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }} onClick={() => go('volunteer-select')}>🙌 Register as Volunteer</button>
    <button style={{ background: '#f5f5f5', color: '#1a1a1a', border: '2px solid #ddd', borderRadius: 7, padding: '13px 24px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }} onClick={() => go('group-select')}>👥 Day Group Registration</button>
    <button style={{ background: '#f5f5f5', color: '#1a1a1a', border: '2px solid #ddd', borderRadius: 7, padding: '13px 24px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }} onClick={() => go('waitlist-select')}>📋 Join Waitlist</button>
  </div>
</div>
</div>
  );
}

// ─── Event Select ──────────────────────────────────────────────────────────
function EventSelect({ type, onSelect, back }) {
  const labels = { athlete: '🏄 Athlete', volunteer: '🙌 Volunteer', group: '👥 Day Group', waitlist: '📋 Waitlist' };
  return (
    <div style={s.page}>
      <button style={s.btnBack} onClick={back}>← Back</button>
      <div style={s.card}>
        <h2 style={s.h2}>{labels[type]} Registration</h2>
        <p style={{ color: '#666', marginBottom: 24 }}>Which event would you like to register for?</p>
        <div style={s.grid2}>
          {Object.entries(EVENTS).map(([k, ev]) => (
            <div key={k} style={s.eventCard} onClick={() => onSelect(k)}>
              <div style={{ fontWeight: 800, fontSize: 20, color: '#4fc3c3' }}>ATL – {ev.label}</div>
              <div style={{ fontWeight: 600, marginTop: 4 }}>{ev.dates}</div>
              <div style={{ color: '#666', fontSize: 13, marginTop: 2 }}>{ev.location}</div>
              <div style={{ color: '#4fc3c3', fontWeight: 700, fontSize: 13, marginTop: 12 }}>Register →</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── Athlete Form ──────────────────────────────────────────────────────────
function AthleteForm({ eventKey, back }) {
  const ev = EVENTS[eventKey];
  const isMI = eventKey === 'MI';
  const totalSteps = isMI ? 5 : 4;
  const stepLabels = isMI
    ? ['Personal Info', 'Emergency Contact', 'Event Details', 'Photo & Consents', 'Waiver & Sign']
    : ['Personal Info', 'Emergency Contact', 'Event Details', 'Waiver & Sign'];

  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [groupInfo, setGroupInfo] = useState(null);
  const [capacity, setCapacity] = useState([]);

useEffect(() => {
  fetch(`${API}/api/capacity?event=${eventKey}`)
    .then(r => r.ok ? r.json() : [])
    .then(setCapacity)
    .catch(() => {});
}, [eventKey]);

const isDayFull = (day) => capacity.find(c => c.day === day)?.full;
  const [f, setF] = useState({
    firstName: '', lastName: '', dob: '', email: '', phone: '', city: '', state: '', zip: '',
    ecName: '', ecRel: '', ecPhone: '', ecEmail: '',
    days: [], activities: [], shirt: '', dietary: '', dietaryOther: '', specialNeeds: '', notes: '',
    hasGuest: false, guestFirst: '', guestLast: '', guestEmail: '', guestPhone: '', guestShirt: '',
    hasGroup: false, groupCode: '',
    photoSigned: false, commConsent: false, wakeParkWaiver: false,
    waiverSigned: false, signatureName: '', signatureDate: new Date().toLocaleDateString(),
    parentSig: '', isMinor: false,
  });
  const u = (k, v) => setF(p => ({ ...p, [k]: v }));

  const validateGroupCode = async () => {
    if (!f.groupCode) return;
    try {
      const res = await fetch(`${API}/api/groups/validate/${f.groupCode.trim().toUpperCase()}`);
      if (res.ok) { const d = await res.json(); setGroupInfo(d.group); }
      else setGroupInfo(null);
    } catch { setGroupInfo(null); }
  };

  const validate = () => {
    if (step === 1 && (!f.firstName || !f.lastName || !f.email || !f.phone || !f.dob)) return 'Please fill in all required fields.';
    if (step === 2 && (!f.ecName || !f.ecPhone)) return 'Please fill in emergency contact name and phone.';
    if (step === 3 && !f.days.length) return 'Please select at least one day.';
    if (isMI && step === 4) {
      if (!f.photoSigned) return 'Please agree to the Photo/Media Release.';
      if (!f.commConsent) return 'Please confirm your communications consent.';
    }
    const waiverStep = isMI ? 5 : 4;
    if (step === waiverStep && (!f.waiverSigned || !f.signatureName)) return 'Please agree to the waiver and provide your electronic signature.';
    return '';
  };

  const next = () => {
    const err = validate();
    if (err) { setError(err); return; }
    setError('');
    if (step === totalSteps) submit(); else setStep(p => p + 1);
  };

  const submit = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/athletes`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...f, event: eventKey }),
      });
      if (!res.ok) throw new Error();
      setSubmitted(true);
    } catch { setError('Something went wrong. Please try again.'); }
    finally { setLoading(false); }
  };

  if (submitted) return (
    <div style={s.page}>
      <div style={{ ...s.card, textAlign: 'center', padding: '48px 24px' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
        <h2 style={s.h2}>Registration Complete!</h2>
        <p>Thank you, <strong>{f.firstName}</strong>! You're registered for <strong>ATL – {ev.label}</strong>.</p>
        <p style={{ color: '#666', fontSize: 13, marginTop: 8 }}>A confirmation email has been sent to {f.email}. See you at the lake!</p>
        <button style={{ ...s.btnPrimary, marginTop: 24 }} onClick={back}>← Back to Home</button>
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <button style={s.btnBack} onClick={back}>← Back</button>
      <div style={s.card}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span style={s.badge('#27ae60')}>ATL – {ev.label}</span>
          <span style={{ color: '#666', fontSize: 13 }}>{ev.dates}</span>
        </div>
        <h2 style={s.h2}>🏄 Athlete Registration</h2>
        {error && <div style={s.alert('error')}>{error}</div>}

        <div style={s.steps}>
          {stepLabels.map((lbl, i) => {
            const st = i + 1 === step ? 'active' : i + 1 < step ? 'done' : '';
            return <div key={lbl} style={s.step(st)} onClick={() => i + 1 < step && setStep(i + 1)}>{i + 1 < step ? '✓ ' : `${i + 1}. `}{lbl}</div>;
          })}
        </div>

        {step === 1 && <>
          <h3 style={s.h3}>Personal Information</h3>
          <div style={s.grid2}>
            <F label="First Name" req><Inp value={f.firstName} onChange={e => u('firstName', e.target.value)} placeholder="First name" /></F>
            <F label="Last Name" req><Inp value={f.lastName} onChange={e => u('lastName', e.target.value)} placeholder="Last name" /></F>
          </div>
          <div style={s.grid2}>
            <F label="Date of Birth" req><Inp type="date" value={f.dob} onChange={e => { u('dob', e.target.value); u('isMinor', new Date().getFullYear() - new Date(e.target.value).getFullYear() < 18); }} /></F>
            <F label="Phone" req><Inp value={f.phone} onChange={e => u('phone', e.target.value)} placeholder="(xxx) xxx-xxxx" /></F>
          </div>
          <F label="Email" req><Inp type="email" value={f.email} onChange={e => u('email', e.target.value)} placeholder="email@example.com" /></F>
          <div style={s.grid3}>
            <F label="City"><Inp value={f.city} onChange={e => u('city', e.target.value)} /></F>
            <F label="State"><Inp value={f.state} onChange={e => u('state', e.target.value)} placeholder="WI" /></F>
            <F label="Zip"><Inp value={f.zip} onChange={e => u('zip', e.target.value)} /></F>
          </div>
          <div style={s.divider} />
          <h3 style={s.h3}>Day Program Group</h3>
          <div style={s.checkRow}>
            <input type="checkbox" checked={f.hasGroup} onChange={e => u('hasGroup', e.target.checked)} />
            <label style={{ fontSize: 14, cursor: 'pointer' }}>I am attending as part of a day program or group</label>
          </div>
          {f.hasGroup && <>
            <F label="Group Code" req>
              <Inp value={f.groupCode} onChange={e => u('groupCode', e.target.value.toUpperCase())} onBlur={validateGroupCode} placeholder="e.g. MDS-WI-A3F2" />
            </F>
            {groupInfo && <div style={{ ...s.alert('success'), marginTop: -8 }}>✓ Group found: <strong>{groupInfo.group_name || groupInfo.organization}</strong> (Leader: {groupInfo.first_name} {groupInfo.last_name})</div>}
          </>}
          <div style={s.divider} />
          <h3 style={s.h3}>Guest / Caregiver</h3>
          <div style={s.checkRow}>
            <input type="checkbox" checked={f.hasGuest} onChange={e => u('hasGuest', e.target.checked)} />
            <label style={{ fontSize: 14, cursor: 'pointer' }}>I will be bringing a guest or caregiver who will participate in activities with me</label>
          </div>
          {f.hasGuest && <>
            <div style={s.grid2}>
              <F label="Guest First Name"><Inp value={f.guestFirst} onChange={e => u('guestFirst', e.target.value)} /></F>
              <F label="Guest Last Name"><Inp value={f.guestLast} onChange={e => u('guestLast', e.target.value)} /></F>
            </div>
            <div style={s.grid2}>
              <F label="Guest Email"><Inp value={f.guestEmail} onChange={e => u('guestEmail', e.target.value)} /></F>
              <F label="Guest Phone"><Inp value={f.guestPhone} onChange={e => u('guestPhone', e.target.value)} /></F>
            </div>
          </>}
        </>}

        {step === 2 && <>
          <h3 style={s.h3}>Emergency Contact</h3>
          <div style={s.grid2}>
            <F label="Contact Name" req><Inp value={f.ecName} onChange={e => u('ecName', e.target.value)} /></F>
            <F label="Relationship"><Inp value={f.ecRel} onChange={e => u('ecRel', e.target.value)} placeholder="e.g. Parent, Spouse" /></F>
          </div>
          <div style={s.grid2}>
            <F label="Phone" req><Inp value={f.ecPhone} onChange={e => u('ecPhone', e.target.value)} /></F>
            <F label="Email"><Inp value={f.ecEmail} onChange={e => u('ecEmail', e.target.value)} /></F>
          </div>
        </>}

        {step === 3 && <>
  <h3 style={s.h3}>Event Day(s)</h3>
  <F label="Which day(s) are you attending?" req>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 6 }}>
      {ev.days.map(day => {
        const full = isDayFull(day);
        return (
          <label key={day} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: full ? 'not-allowed' : 'pointer', opacity: full ? 0.5 : 1 }}>
            <input type="checkbox" disabled={full} checked={f.days.includes(day)}
              onChange={() => u('days', f.days.includes(day) ? f.days.filter(x => x !== day) : [...f.days, day])} />
            {day}
            {full && <span style={{ ...s.badge('#e74c3c'), marginLeft: 6 }}>FULL — Join Waitlist</span>}
          </label>
        );
      })}
    </div>
  </F>
  {ev.days.some(isDayFull) && (
    <div style={{ ...s.alert('error'), marginTop: -6 }}>
      One or more days are at capacity. You can still register for available days, or{' '}
      <span onClick={() => { back(); }} style={{ color: '#e74c3c', fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}>go back and join the waitlist from the home page</span>
    </div>
  )}
          <div style={s.divider} />
          <h3 style={s.h3}>Activity Preferences</h3>
          <p style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>Select all activities you're interested in:</p>
          <CheckList opts={ev.activities} selected={f.activities} onChange={v => u('activities', v)} cols={2} />
          <div style={s.divider} />
          <div style={s.field}>
            <F label="Dietary Restrictions"><Sel opts={DIETARY} value={f.dietary} onChange={e => u('dietary', e.target.value)} /></F>
          </div>
          {f.dietary === 'Other' && <F label="Please describe"><Inp value={f.dietaryOther} onChange={e => u('dietaryOther', e.target.value)} /></F>}
          <F label="Special Needs / Accommodations"><textarea style={s.textarea} value={f.specialNeeds} onChange={e => u('specialNeeds', e.target.value)} placeholder="Please describe any physical, medical, or accessibility needs we should know about..." /></F>
          <F label="Additional Notes"><textarea style={s.textarea} value={f.notes} onChange={e => u('notes', e.target.value)} placeholder="Anything else you'd like us to know?" /></F>
        </>}

        {isMI && step === 4 && <>
          <h3 style={s.h3}>Photo / Media Release</h3>
          <div style={s.waiverBox}>{PHOTO_RELEASE}</div>
          <div style={s.checkRow}>
            <input type="checkbox" checked={f.photoSigned} onChange={e => u('photoSigned', e.target.checked)} />
            <label style={{ fontSize: 13, cursor: 'pointer' }}>I agree to the Anthros Foundation Photo/Media Release above. <span style={{ color: '#e74c3c' }}>*</span></label>
          </div>
          <div style={s.divider} />
          <h3 style={s.h3}>Communications Consent</h3>
          <div style={s.waiverBox}>{COMM_CONSENT}</div>
          <div style={s.checkRow}>
            <input type="checkbox" checked={f.commConsent} onChange={e => u('commConsent', e.target.checked)} />
            <label style={{ fontSize: 13, cursor: 'pointer' }}>I agree to receive communications from the Anthros Foundation. <span style={{ color: '#e74c3c' }}>*</span></label>
          </div>
        </>}

        {step === totalSteps && <>
          {!isMI && <>
            <h3 style={s.h3}>Photo / Media Release</h3>
            <div style={s.waiverBox}>{PHOTO_RELEASE}</div>
            <div style={s.checkRow}>
              <input type="checkbox" checked={f.photoSigned} onChange={e => u('photoSigned', e.target.checked)} />
              <label style={{ fontSize: 13, cursor: 'pointer' }}>I agree to the Anthros Foundation Photo/Media Release above.</label>
            </div>
            <div style={s.divider} />
            <h3 style={s.h3}>Liability Waiver & Release</h3>
            <div style={s.waiverBox}>{WAIVER}</div>
            <div style={s.checkRow}>
              <input type="checkbox" checked={f.waiverSigned} onChange={e => u('waiverSigned', e.target.checked)} />
              <label style={{ fontSize: 13, cursor: 'pointer' }}>I have read and agree to the Liability Waiver and Release of Liability above. <span style={{ color: '#e74c3c' }}>*</span></label>
            </div>
            {f.hasGuest && <div style={s.checkRow}>
              <input type="checkbox" />
              <label style={{ fontSize: 13, cursor: 'pointer' }}>My guest/caregiver ({f.guestFirst} {f.guestLast}) also agrees to all waiver terms above.</label>
            </div>}
            <div style={s.divider} />
            <div style={s.grid2}>
              <F label="Full Legal Name (Electronic Signature)" req><Inp value={f.signatureName} onChange={e => u('signatureName', e.target.value)} placeholder="Type your full name" /></F>
              <F label="Date"><Inp value={f.signatureDate} readOnly /></F>
            </div>
            {f.isMinor && <F label="Parent/Guardian Signature (required for minors)" req><Inp value={f.parentSig} onChange={e => u('parentSig', e.target.value)} /></F>}
          </>}

          {isMI && <>
            <div style={s.wakeParkBox}>
              <h3 style={{ ...s.h3, marginTop: 0, color: '#856404', fontSize: 15 }}>⚠️ Liability Waiver — Action Wake Park Participant Agreement</h3>
              <p style={{ fontSize: 13, lineHeight: 1.7, marginBottom: 12 }}>
                In place of a standard liability waiver, all Michigan event participants are required to complete the <strong>Action Wake Park Participant Agreement</strong>. Please click the button below to open and complete the form in a new tab. Once submitted, return here to confirm and complete your registration.
              </p>
              <a
                href="https://app.rockgympro.com/waiver/esign/actionwakeparkmi/b1c67b9c-ba13-4514-865f-76d9768ff37b"
                target="_blank"
                rel="noreferrer"
                style={{ display: 'inline-block', background: '#1a1a1a', color: '#fff', padding: '11px 22px', borderRadius: 7, textDecoration: 'none', fontWeight: 700, fontSize: 14, marginBottom: 14 }}>
                Complete Action Wake Park Participant Agreement →
              </a>
              <div style={s.checkRow}>
                <input type="checkbox" checked={f.waiverSigned} onChange={e => u('waiverSigned', e.target.checked)} />
                <label style={{ fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                  I confirm that I have completed and submitted the Action Wake Park Participant Agreement at the link above. <span style={{ color: '#e74c3c' }}>*</span>
                </label>
              </div>
            </div>
            <div style={s.divider} />
            <div style={s.grid2}>
              <F label="Full Legal Name (Electronic Signature)" req><Inp value={f.signatureName} onChange={e => u('signatureName', e.target.value)} placeholder="Type your full name" /></F>
              <F label="Date"><Inp value={f.signatureDate} readOnly /></F>
            </div>
            {f.isMinor && <F label="Parent/Guardian Signature (required for minors)" req><Inp value={f.parentSig} onChange={e => u('parentSig', e.target.value)} /></F>}
          </>}
        </>}

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
          {step > 1 ? <button style={s.btnSecondary} onClick={() => { setError(''); setStep(p => p - 1); }}>← Previous</button> : <div />}
          <button style={{ ...s.btnPrimary, opacity: loading ? 0.6 : 1 }} onClick={next} disabled={loading}>
            {loading ? 'Submitting…' : step === totalSteps ? 'Submit Registration ✓' : 'Next →'}
          </button>
        </div>
      </div>
    </div>
  );
}
function WaitlistForm({ eventKey, back }) {
  const ev = EVENTS[eventKey];
  const [f, setF] = useState({ firstName: '', lastName: '', email: '', phone: '', day: '', notes: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const u = (k, v) => setF(p => ({ ...p, [k]: v }));

  const submit = async () => {
    if (!f.firstName || !f.lastName || !f.email) { setError('Name and email are required.'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/waitlist`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...f, event: eventKey }),
      });
      if (!res.ok) throw new Error();
      setSubmitted(true);
    } catch { setError('Something went wrong. Please try again.'); }
    finally { setLoading(false); }
  };

  if (submitted) return (
    <div style={s.page}>
      <div style={{ ...s.card, textAlign: 'center', padding: '48px 24px' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>📋</div>
        <h2 style={s.h2}>You're on the Waitlist!</h2>
        <p>Thank you, <strong>{f.firstName}</strong>! We'll reach out if a spot opens up for <strong>ATL – {ev.label}</strong>.</p>
        <button style={{ ...s.btnPrimary, marginTop: 24 }} onClick={back}>← Back to Home</button>
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <button style={s.btnBack} onClick={back}>← Back</button>
      <div style={s.card}>
        <h2 style={s.h2}>📋 Join the Waitlist</h2>
        <p style={{ color: '#666', marginBottom: 20 }}>ATL – {ev.label} is currently full for one or more days. Leave your info and we'll contact you if a spot opens up.</p>
        {error && <div style={s.alert('error')}>{error}</div>}
        <div style={s.grid2}>
          <F label="First Name" req><Inp value={f.firstName} onChange={e => u('firstName', e.target.value)} /></F>
          <F label="Last Name" req><Inp value={f.lastName} onChange={e => u('lastName', e.target.value)} /></F>
        </div>
        <F label="Email" req><Inp type="email" value={f.email} onChange={e => u('email', e.target.value)} /></F>
        <F label="Phone"><Inp value={f.phone} onChange={e => u('phone', e.target.value)} /></F>
        <F label="Which day were you hoping for?">
          <Sel opts={ev.days} value={f.day} onChange={e => u('day', e.target.value)} />
        </F>
        <F label="Notes"><textarea style={s.textarea} value={f.notes} onChange={e => u('notes', e.target.value)} placeholder="Anything else we should know?" /></F>
        <button style={{ ...s.btnPrimary, width: '100%', marginTop: 12 }} onClick={submit} disabled={loading}>{loading ? 'Submitting…' : 'Join Waitlist'}</button>
      </div>
    </div>
  );
}
// ─── Volunteer Form ────────────────────────────────────────────────────────
function VolunteerForm({ eventKey, back }) {
  const ev = EVENTS[eventKey];
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [f, setF] = useState({
    firstName: '', lastName: '', dob: '', email: '', phone: '', city: '', state: '',
    ecName: '', ecPhone: '',
    days: [], roles: [], skills: '', canSwim: '', canLift: '',
    shirt: '', notes: '',
    waiverSigned: false, photoSigned: false, commConsent: false,
    signatureName: '', signatureDate: new Date().toLocaleDateString(),
    parentSig: '', isMinor: false,
  });
  const u = (k, v) => setF(p => ({ ...p, [k]: v }));

  const validate = () => {
    if (step === 1 && (!f.firstName || !f.lastName || !f.email || !f.phone || !f.ecName || !f.ecPhone)) return 'Please fill in all required fields.';
    if (step === 2 && (!f.days.length || !f.shirt)) return 'Please select at least one day and a t-shirt size.';
    if (step === 3 && (!f.waiverSigned || !f.photoSigned || !f.signatureName)) return 'Please agree to all waivers and provide your signature.';
    if (step === 3 && eventKey === 'MI' && !f.commConsent) return 'Please confirm your communications consent.';
    return '';
  };

  const next = () => {
    const err = validate();
    if (err) { setError(err); return; }
    setError('');
    if (step === 3) submit(); else setStep(p => p + 1);
  };

  const submit = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/volunteers`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...f, event: eventKey }),
      });
      if (!res.ok) throw new Error();
      setSubmitted(true);
    } catch { setError('Something went wrong. Please try again.'); }
    finally { setLoading(false); }
  };

  if (submitted) return (
    <div style={s.page}>
      <div style={{ ...s.card, textAlign: 'center', padding: '48px 24px' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>🙌</div>
        <h2 style={s.h2}>Thank You for Volunteering!</h2>
        <p>Thank you, <strong>{f.firstName}</strong>! You've registered to volunteer at <strong>ATL – {ev.label}</strong>.</p>
        <p style={{ color: '#666', fontSize: 13, marginTop: 8 }}>A confirmation email has been sent to {f.email}. We can't wait to see you there!</p>
        <button style={{ ...s.btnPrimary, marginTop: 24 }} onClick={back}>← Back to Home</button>
      </div>
    </div>
  );

  const stepLabels = ['Personal Info', 'Volunteer Details', 'Waiver & Sign'];
  return (
    <div style={s.page}>
      <button style={s.btnBack} onClick={back}>← Back</button>
      <div style={s.card}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span style={s.badge('#2980b9')}>ATL – {ev.label}</span>
          <span style={{ color: '#666', fontSize: 13 }}>{ev.dates}</span>
        </div>
        <h2 style={s.h2}>🙌 Volunteer Registration</h2>
        {error && <div style={s.alert('error')}>{error}</div>}
        <div style={s.steps}>
          {stepLabels.map((lbl, i) => {
            const st = i + 1 === step ? 'active' : i + 1 < step ? 'done' : '';
            return <div key={lbl} style={s.step(st)} onClick={() => i + 1 < step && setStep(i + 1)}>{i + 1 < step ? '✓ ' : `${i + 1}. `}{lbl}</div>;
          })}
        </div>

        {step === 1 && <>
          <h3 style={s.h3}>Personal Information</h3>
          <div style={s.grid2}>
            <F label="First Name" req><Inp value={f.firstName} onChange={e => u('firstName', e.target.value)} /></F>
            <F label="Last Name" req><Inp value={f.lastName} onChange={e => u('lastName', e.target.value)} /></F>
          </div>
          <div style={s.grid2}>
            <F label="Date of Birth"><Inp type="date" value={f.dob} onChange={e => { u('dob', e.target.value); u('isMinor', new Date().getFullYear() - new Date(e.target.value).getFullYear() < 18); }} /></F>
            <F label="Phone" req><Inp value={f.phone} onChange={e => u('phone', e.target.value)} /></F>
          </div>
          <F label="Email" req><Inp type="email" value={f.email} onChange={e => u('email', e.target.value)} /></F>
          <div style={s.grid2}>
            <F label="City"><Inp value={f.city} onChange={e => u('city', e.target.value)} /></F>
            <F label="State"><Inp value={f.state} onChange={e => u('state', e.target.value)} /></F>
          </div>
          <div style={s.divider} />
          <h3 style={s.h3}>Emergency Contact</h3>
          <div style={s.grid2}>
            <F label="Contact Name" req><Inp value={f.ecName} onChange={e => u('ecName', e.target.value)} /></F>
            <F label="Contact Phone" req><Inp value={f.ecPhone} onChange={e => u('ecPhone', e.target.value)} /></F>
          </div>
        </>}

        {step === 2 && <>
          <h3 style={s.h3}>Availability</h3>
          <F label="Which day(s) can you volunteer?" req>
            <CheckList opts={ev.days} selected={f.days} onChange={v => u('days', v)} cols={1} />
          </F>
          <div style={s.divider} />
          <h3 style={s.h3}>Role Preferences</h3>
          <p style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>Select the roles you're most interested in. Hover over the <span style={{ color: '#4fc3c3', fontWeight: 700 }}>ⓘ</span> icon for a description of each role.</p>
          {Object.entries(ev.volunteerRoles).map(([cat, roles]) => (
            <div key={cat} style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 700, fontSize: 12, color: '#4fc3c3', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>{cat}</div>
              <RoleCheckList
                opts={roles}
                selected={f.roles}
                onChange={v => u('roles', v)}
                descriptions={eventKey === 'MI' ? MI_ROLE_DESCRIPTIONS : WI_ROLE_DESCRIPTIONS}
              />
            </div>
          ))}
          <div style={s.divider} />
          <h3 style={s.h3}>Skills & Qualifications</h3>
          <F label="Relevant skills, certifications, or experience">
            <textarea style={s.textarea} value={f.skills} onChange={e => u('skills', e.target.value)} placeholder="e.g. Certified lifeguard, physical therapist, adaptive sports experience, boat driving license..." />
          </F>
          <div style={s.grid2}>
            <F label="Can you swim with a life jacket?"><Sel opts={['Yes', 'No', 'Unsure']} value={f.canSwim} onChange={e => u('canSwim', e.target.value)} /></F>
            <F label="Can you lift 30 lbs?"><Sel opts={['Yes', 'No', 'With assistance']} value={f.canLift} onChange={e => u('canLift', e.target.value)} /></F>
          </div>
          <F label="T-Shirt Size" req><Sel opts={SHIRT_SIZES} value={f.shirt} onChange={e => u('shirt', e.target.value)} /></F>
          <F label="Additional Notes"><textarea style={s.textarea} value={f.notes} onChange={e => u('notes', e.target.value)} placeholder="Camera/GoPro to lend? Student hour forms needed? Anything else?" /></F>
        </>}

        {step === 3 && <>
          <h3 style={s.h3}>Photo / Media Release</h3>
          <div style={s.waiverBox}>{PHOTO_RELEASE}</div>
          <div style={s.checkRow}>
            <input type="checkbox" checked={f.photoSigned} onChange={e => u('photoSigned', e.target.checked)} />
            <label style={{ fontSize: 13, cursor: 'pointer' }}>I agree to the Anthros Foundation Photo/Media Release above. <span style={{ color: '#e74c3c' }}>*</span></label>
          </div>
          <div style={s.divider} />

          {eventKey === 'MI' ? <>
            <h3 style={s.h3}>Communications Consent</h3>
            <div style={s.waiverBox}>{COMM_CONSENT}</div>
            <div style={s.checkRow}>
              <input type="checkbox" checked={f.commConsent} onChange={e => u('commConsent', e.target.checked)} />
              <label style={{ fontSize: 13, cursor: 'pointer' }}>I agree to receive communications from the Anthros Foundation. <span style={{ color: '#e74c3c' }}>*</span></label>
            </div>
            <div style={s.divider} />
            <div style={s.wakeParkBox}>
              <h3 style={{ ...s.h3, marginTop: 0, color: '#856404', fontSize: 15 }}>⚠️ Liability Waiver — Action Wake Park Participant Agreement</h3>
              <p style={{ fontSize: 13, lineHeight: 1.7, marginBottom: 12 }}>All Michigan event participants are required to complete the <strong>Action Wake Park Participant Agreement</strong>. Click the button below to open and complete the form in a new tab. Once submitted, return here to confirm and complete your registration.</p>
              <a href="https://app.rockgympro.com/waiver/esign/actionwakeparkmi/b1c67b9c-ba13-4514-865f-76d9768ff37b" target="_blank" rel="noreferrer"
                style={{ display: 'inline-block', background: '#1a1a1a', color: '#fff', padding: '11px 22px', borderRadius: 7, textDecoration: 'none', fontWeight: 700, fontSize: 14, marginBottom: 14 }}>
                Complete Action Wake Park Participant Agreement →
              </a>
              <div style={s.checkRow}>
                <input type="checkbox" checked={f.waiverSigned} onChange={e => u('waiverSigned', e.target.checked)} />
                <label style={{ fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>I confirm that I have completed and submitted the Action Wake Park Participant Agreement at the link above. <span style={{ color: '#e74c3c' }}>*</span></label>
              </div>
            </div>
          </> : <>
            <h3 style={s.h3}>Liability Waiver & Release</h3>
            <div style={s.waiverBox}>{WAIVER}</div>
            <div style={s.checkRow}>
              <input type="checkbox" checked={f.waiverSigned} onChange={e => u('waiverSigned', e.target.checked)} />
              <label style={{ fontSize: 13, cursor: 'pointer' }}>I have read and agree to the Liability Waiver and Release of Liability above. <span style={{ color: '#e74c3c' }}>*</span></label>
            </div>
          </>}

          <div style={s.divider} />
          <div style={s.grid2}>
            <F label="Full Legal Name (Electronic Signature)" req><Inp value={f.signatureName} onChange={e => u('signatureName', e.target.value)} placeholder="Type your full name" /></F>
            <F label="Date"><Inp value={f.signatureDate} readOnly /></F>
          </div>
          {f.isMinor && <F label="Parent/Guardian Signature (required for minors)" req><Inp value={f.parentSig} onChange={e => u('parentSig', e.target.value)} /></F>}
        </>}

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
          {step > 1 ? <button style={s.btnSecondary} onClick={() => { setError(''); setStep(p => p - 1); }}>← Previous</button> : <div />}
          <button style={{ ...s.btnPrimary, opacity: loading ? 0.6 : 1 }} onClick={next} disabled={loading}>
            {loading ? 'Submitting…' : step === 3 ? 'Submit Registration ✓' : 'Next →'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Group Leader Form ─────────────────────────────────────────────────────
const newAthlete = () => ({
  id: Math.random().toString(36).slice(2, 9),
  firstName: '', lastName: '', dob: '', dietary: '', dietaryOther: '',
  specialNeeds: '', activities: [],
  waiverSigned: false, photoSigned: false, signatureName: '',
  expanded: true,
});

function AthleteCard({ athlete, index, ev, onChange, onRemove }) {
  const u = (k, v) => onChange({ ...athlete, [k]: v });
  const complete = athlete.firstName && athlete.lastName && athlete.waiverSigned && athlete.photoSigned && athlete.signatureName;

  return (
    <div style={{ border: `2px solid ${complete ? '#4fc3c3' : '#ddd'}`, borderRadius: 10, marginBottom: 12, overflow: 'hidden' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: complete ? '#e8f9f9' : '#f9f9f9', cursor: 'pointer' }}
        onClick={() => u('expanded', !athlete.expanded)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontWeight: 800, fontSize: 15 }}>
            {complete ? '✅ ' : '⭕ '}
            Athlete {index + 1}{athlete.firstName ? `: ${athlete.firstName} ${athlete.lastName}` : ''}
          </span>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button onClick={e => { e.stopPropagation(); onRemove(); }} style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>✕</button>
          <span style={{ color: '#999', fontSize: 18 }}>{athlete.expanded ? '▲' : '▼'}</span>
        </div>
      </div>

      {/* Body */}
      {athlete.expanded && (
        <div style={{ padding: 16 }}>
          <div style={s.grid2}>
            <F label="First Name" req><Inp value={athlete.firstName} onChange={e => u('firstName', e.target.value)} placeholder="First name" /></F>
            <F label="Last Name" req><Inp value={athlete.lastName} onChange={e => u('lastName', e.target.value)} placeholder="Last name" /></F>
          </div>
          <div style={s.grid2}>
            <F label="Date of Birth" req><Inp type="date" value={athlete.dob} onChange={e => u('dob', e.target.value)} /></F>
            <F label="Dietary Restrictions">
              <Sel opts={DIETARY} value={athlete.dietary} onChange={e => u('dietary', e.target.value)} />
            </F>
          </div>
          {athlete.dietary === 'Other' && <F label="Please describe"><Inp value={athlete.dietaryOther} onChange={e => u('dietaryOther', e.target.value)} /></F>}
          <F label="Special Needs / Accommodations">
            <textarea style={s.textarea} value={athlete.specialNeeds} onChange={e => u('specialNeeds', e.target.value)} placeholder="Any physical, medical, or accessibility needs we should know about..." />
          </F>
          <F label="Activity Preferences">
            <CheckList opts={ev.activities} selected={athlete.activities} onChange={v => u('activities', v)} cols={2} />
          </F>

          <div style={s.divider} />
          <h3 style={{ ...s.h3, marginTop: 0, fontSize: 13, color: '#555' }}>Waiver for {athlete.firstName || `Athlete ${index + 1}`}</h3>
          <div style={{ ...s.waiverBox, maxHeight: 120 }}>{PHOTO_RELEASE}</div>
          <div style={s.checkRow}>
            <input type="checkbox" checked={athlete.photoSigned} onChange={e => u('photoSigned', e.target.checked)} />
            <label style={{ fontSize: 12, cursor: 'pointer' }}>I agree to the Photo/Media Release for this participant. <span style={{ color: '#e74c3c' }}>*</span></label>
          </div>
          <div style={{ ...s.waiverBox, maxHeight: 100, marginTop: 8 }}>{WAIVER}</div>
          <div style={s.checkRow}>
            <input type="checkbox" checked={athlete.waiverSigned} onChange={e => u('waiverSigned', e.target.checked)} />
            <label style={{ fontSize: 12, cursor: 'pointer' }}>I agree to the Liability Waiver on behalf of this participant and have authority to do so. <span style={{ color: '#e74c3c' }}>*</span></label>
          </div>
          <F label="Participant Full Legal Name (Electronic Signature)" req>
            <Inp value={athlete.signatureName} onChange={e => u('signatureName', e.target.value)} placeholder="Type participant's full legal name" />
          </F>
        </div>
      )}
    </div>
  );
}

function GroupLeaderForm({ eventKey, back }) {
  const ev = EVENTS[eventKey];
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [groupCode, setGroupCode] = useState('');
  const [athletes, setAthletes] = useState([newAthlete()]);
  const [f, setF] = useState({
    firstName: '', lastName: '', email: '', phone: '', city: '', state: '',
    organization: '', groupName: '',
    days: [], expectedHeadcount: '', notes: '',
    waiverSigned: false, photoSigned: false,
    signatureName: '', signatureDate: new Date().toLocaleDateString(),
  });
  const u = (k, v) => setF(p => ({ ...p, [k]: v }));

  const addAthlete = () => {
    if (athletes.length >= 50) return;
    setAthletes(prev => [...prev.map(a => ({ ...a, expanded: false })), newAthlete()]);
  };

  const updateAthlete = (idx, updated) => setAthletes(prev => prev.map((a, i) => i === idx ? updated : a));
  const removeAthlete = (idx) => setAthletes(prev => prev.filter((_, i) => i !== idx));

  const validate = () => {
    if (step === 1 && (!f.firstName || !f.lastName || !f.email || !f.phone || !f.organization)) return 'Please fill in all required fields.';
    if (step === 2 && !f.days.length) return 'Please select at least one day.';
    if (step === 3) {
      if (athletes.length === 0) return 'Please add at least one athlete.';
      for (let i = 0; i < athletes.length; i++) {
        const a = athletes[i];
        if (!a.firstName || !a.lastName || !a.dob) return `Athlete ${i + 1} is missing required fields (name and date of birth).`;
        if (!a.waiverSigned || !a.photoSigned || !a.signatureName) return `Athlete ${i + 1} waiver is incomplete. Please sign and agree to all waivers.`;
      }
    }
    if (step === 4 && (!f.waiverSigned || !f.photoSigned || !f.signatureName)) return 'Please agree to all waivers and provide your signature.';
    return '';
  };

  const next = () => {
    const err = validate();
    if (err) { setError(err); return; }
    setError('');
    if (step === 4) submit(); else setStep(p => p + 1);
  };

  const submit = async () => {
    setLoading(true);
    try {
      // Register group leader
      const res = await fetch(`${API}/api/groups`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...f, event: eventKey, expectedHeadcount: athletes.length }),
      });
      if (!res.ok) throw new Error();
      const data = await res.json();
      const gCode = data.groupCode;
      const gId = data.id;

      // Register each athlete linked to this group
      await Promise.all(athletes.map(a =>
        fetch(`${API}/api/athletes`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            firstName: a.firstName, lastName: a.lastName, dob: a.dob,
            email: f.email, phone: f.phone,
            ecName: `${f.firstName} ${f.lastName}`, ecPhone: f.phone,
            days: f.days, activities: a.activities,
            dietary: a.dietary, dietaryOther: a.dietaryOther,
            specialNeeds: a.specialNeeds,
            waiverSigned: a.waiverSigned, photoSigned: a.photoSigned,
            signatureName: a.signatureName, signatureDate: f.signatureDate,
            groupCode: gCode, event: eventKey,
          }),
        })
      ));

      setGroupCode(gCode);
      setSubmitted(true);
    } catch { setError('Something went wrong. Please try again.'); }
    finally { setLoading(false); }
  };

  const completedCount = athletes.filter(a => a.firstName && a.lastName && a.waiverSigned && a.photoSigned && a.signatureName).length;

  if (submitted) return (
    <div style={s.page}>
      <div style={{ ...s.card, textAlign: 'center', padding: '48px 24px' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>👥</div>
        <h2 style={s.h2}>Group Registration Complete!</h2>
        <p>Thank you, <strong>{f.firstName}</strong>! Your group and <strong>{athletes.length} athlete{athletes.length > 1 ? 's' : ''}</strong> have been registered for <strong>ATL – {ev.label}</strong>.</p>
        <div style={{ background: '#e8f9f9', border: '2px solid #4fc3c3', borderRadius: 10, padding: 20, margin: '20px auto', maxWidth: 360 }}>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>Your Group Code</div>
          <div style={{ fontSize: 36, fontWeight: 800, color: '#4fc3c3', letterSpacing: 3 }}>{groupCode}</div>
          <div style={{ fontSize: 13, color: '#666', marginTop: 8 }}>Keep this code for your records. All your athletes have been registered and linked to your group.</div>
        </div>
        <div style={{ background: '#f9f9f9', borderRadius: 8, padding: 16, margin: '16px 0', textAlign: 'left' }}>
          <div style={{ fontWeight: 700, marginBottom: 8, fontSize: 13 }}>Registered Athletes:</div>
          {athletes.map((a, i) => <div key={i} style={{ fontSize: 13, padding: '4px 0', borderBottom: '1px solid #eee' }}>✅ {a.firstName} {a.lastName}</div>)}
        </div>
        <p style={{ color: '#666', fontSize: 13 }}>A confirmation email has been sent to {f.email}.</p>
        <button style={{ ...s.btnPrimary, marginTop: 20 }} onClick={back}>← Back to Home</button>
      </div>
    </div>
  );

  const stepLabels = ['Group Info', 'Event Details', 'Register Athletes', 'Leader Waiver'];
  return (
    <div style={s.page}>
      <button style={s.btnBack} onClick={back}>← Back</button>
      <div style={s.card}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span style={s.badge('#8e44ad')}>ATL – {ev.label}</span>
          <span style={{ color: '#666', fontSize: 13 }}>{ev.dates}</span>
        </div>
        <h2 style={s.h2}>👥 Day Group Registration</h2>
        <div style={{ background: '#f0f0ff', border: '1.5px solid #8e44ad', borderRadius: 7, padding: '12px 16px', marginBottom: 16, fontSize: 13 }}>
          <strong>Day Program / Group Leader:</strong> Register your group and all athletes in one form. Each athlete's waiver must be individually signed.
        </div>
        {error && <div style={s.alert('error')}>{error}</div>}

        <div style={s.steps}>
          {stepLabels.map((lbl, i) => {
            const st = i + 1 === step ? 'active' : i + 1 < step ? 'done' : '';
            return <div key={lbl} style={s.step(st)} onClick={() => i + 1 < step && setStep(i + 1)}>{i + 1 < step ? '✓ ' : `${i + 1}. `}{lbl}</div>;
          })}
        </div>

        {step === 1 && <>
          <h3 style={s.h3}>Organization / Program</h3>
          <F label="Organization / Program Name" req><Inp value={f.organization} onChange={e => u('organization', e.target.value)} placeholder="e.g. Milwaukee Day Services" /></F>
          <F label="Group Name (optional)"><Inp value={f.groupName} onChange={e => u('groupName', e.target.value)} placeholder="e.g. Group A" /></F>
          <div style={s.divider} />
          <h3 style={s.h3}>Group Leader Contact</h3>
          <div style={s.grid2}>
            <F label="First Name" req><Inp value={f.firstName} onChange={e => u('firstName', e.target.value)} /></F>
            <F label="Last Name" req><Inp value={f.lastName} onChange={e => u('lastName', e.target.value)} /></F>
          </div>
          <div style={s.grid2}>
            <F label="Email" req><Inp type="email" value={f.email} onChange={e => u('email', e.target.value)} /></F>
            <F label="Phone" req><Inp value={f.phone} onChange={e => u('phone', e.target.value)} /></F>
          </div>
          <div style={s.grid2}>
            <F label="City"><Inp value={f.city} onChange={e => u('city', e.target.value)} /></F>
            <F label="State"><Inp value={f.state} onChange={e => u('state', e.target.value)} /></F>
          </div>
        </>}

        {step === 2 && <>
          <h3 style={s.h3}>Attending Day(s)</h3>
          <F label="Which day(s) will your group attend?" req>
            <CheckList opts={ev.days} selected={f.days} onChange={v => u('days', v)} cols={1} />
          </F>
          <F label="Additional Notes">
            <textarea style={s.textarea} value={f.notes} onChange={e => u('notes', e.target.value)} placeholder="Any special accommodations or notes about your group?" />
          </F>
        </>}

        {step === 3 && <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div>
              <h3 style={{ ...s.h3, margin: 0 }}>Athletes ({athletes.length}/50)</h3>
              <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>{completedCount} of {athletes.length} waivers complete</div>
            </div>
            <button style={{ ...s.btnPrimary, padding: '8px 16px', fontSize: 14, opacity: athletes.length >= 50 ? 0.5 : 1 }} onClick={addAthlete} disabled={athletes.length >= 50}>
              + Add Athlete
            </button>
          </div>

          {/* Progress bar */}
          <div style={{ height: 6, background: '#eee', borderRadius: 3, marginBottom: 16 }}>
            <div style={{ height: 6, background: '#4fc3c3', borderRadius: 3, width: `${athletes.length > 0 ? (completedCount / athletes.length) * 100 : 0}%`, transition: 'width .3s' }} />
          </div>

          {athletes.map((a, i) => (
            <AthleteCard key={a.id} athlete={a} index={i} ev={ev}
              onChange={updated => updateAthlete(i, updated)}
              onRemove={() => removeAthlete(i)} />
          ))}

          {athletes.length < 50 && (
            <button style={{ ...s.btnSecondary, width: '100%', marginTop: 8, padding: 12 }} onClick={addAthlete}>
              + Add Another Athlete
            </button>
          )}
        </>}

        {step === 4 && <>
          <p style={{ fontSize: 14, color: '#555', marginBottom: 16 }}>
            Finally, please sign on behalf of yourself as the group leader for <strong>{f.organization}</strong>.
          </p>
          <h3 style={s.h3}>Photo / Media Release</h3>
          <div style={s.waiverBox}>{PHOTO_RELEASE}</div>
          <div style={s.checkRow}>
            <input type="checkbox" checked={f.photoSigned} onChange={e => u('photoSigned', e.target.checked)} />
            <label style={{ fontSize: 13, cursor: 'pointer' }}>I agree to the Photo/Media Release on behalf of myself as group leader. <span style={{ color: '#e74c3c' }}>*</span></label>
          </div>
          <div style={s.divider} />
          <h3 style={s.h3}>Liability Waiver & Release</h3>
          <div style={s.waiverBox}>{WAIVER}</div>
          <div style={s.checkRow}>
            <input type="checkbox" checked={f.waiverSigned} onChange={e => u('waiverSigned', e.target.checked)} />
            <label style={{ fontSize: 13, cursor: 'pointer' }}>I have read and agree to the Liability Waiver on behalf of myself. <span style={{ color: '#e74c3c' }}>*</span></label>
          </div>
          <div style={s.divider} />
          <div style={s.grid2}>
            <F label="Group Leader Full Legal Name (Electronic Signature)" req>
              <Inp value={f.signatureName} onChange={e => u('signatureName', e.target.value)} placeholder="Type your full name" />
            </F>
            <F label="Date"><Inp value={f.signatureDate} readOnly /></F>
          </div>
        </>}

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
          {step > 1 ? <button style={s.btnSecondary} onClick={() => { setError(''); setStep(p => p - 1); }}>← Previous</button> : <div />}
          <button style={{ ...s.btnPrimary, opacity: loading ? 0.6 : 1 }} onClick={next} disabled={loading}>
            {loading ? 'Submitting…' : step === 4 ? `Submit Group Registration (${athletes.length} athletes) ✓` : 'Next →'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Admin Login ───────────────────────────────────────────────────────────
function AdminLogin({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const login = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/admin/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password: pw }),
      });
      const data = await res.json();
      if (res.ok) onSuccess(data.token);
      else setErr(data.error || 'Incorrect email or password.');
    } catch { setErr('Could not connect to server.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a1a1a' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 40, width: 340, boxShadow: '0 8px 32px rgba(0,0,0,.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontWeight: 800, fontSize: 22 }}>At The Lake</div>
          <div style={{ fontSize: 11, color: '#888', letterSpacing: 2, marginTop: 2 }}>ADMIN PORTAL</div>
        </div>
        <F label="Email"><Inp type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" /></F>
        <F label="Password"><Inp type="password" value={pw} onChange={e => setPw(e.target.value)} onKeyDown={e => e.key === 'Enter' && login()} placeholder="Enter password" /></F>
        {err && <div style={{ color: '#e74c3c', fontSize: 13, marginBottom: 8 }}>{err}</div>}
        <button style={{ ...s.btnPrimary, width: '100%' }} onClick={login} disabled={loading}>{loading ? 'Logging in…' : 'Login'}</button>
      </div>
    </div>
  );
}

function CommMessage({ c, h, onSendNow }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <strong>{c.subject}</strong>
          <span style={{ background: c.status === 'scheduled' ? '#8e44ad' : '#27ae60', color: '#fff', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700, marginLeft: 8 }}>{c.status === 'scheduled' ? '🗓 Scheduled' : '✓ Sent'}</span>
        </div>
        <span style={{ fontSize: 12, color: '#999', flexShrink: 0, marginLeft: 8 }}>{new Date(c.sent_at).toLocaleDateString()}</span>
      </div>
      <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
        To: <strong>{c.recipient_type}</strong> · Event: <strong>{c.event_filter === 'ALL' ? 'Both' : `ATL–${c.event_filter}`}</strong> · <strong>{c.recipient_count} recipients</strong>
        {c.scheduled_for && <> · Scheduled: <strong>{new Date(c.scheduled_for).toLocaleString()}</strong></>}
      </div>
      <div style={{ fontSize: 13, color: '#555', marginTop: 6, whiteSpace: 'pre-wrap', background: expanded ? '#f9f9f9' : 'transparent', padding: expanded ? '10px 12px' : 0, borderRadius: expanded ? 6 : 0 }}>
        {expanded ? c.body : `${c.body?.slice(0, 150)}${c.body?.length > 150 ? '…' : ''}`}
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <button style={{ background: '#f0f0f0', color: '#1a1a1a', border: 'none', borderRadius: 5, padding: '5px 12px', fontWeight: 600, fontSize: 12, cursor: 'pointer' }} onClick={() => setExpanded(e => !e)}>
          {expanded ? '▲ Collapse' : '▼ View Full Message'}
        </button>
        {c.status === 'scheduled' && (
          <button style={{ background: '#4fc3c3', color: '#1a1a1a', border: 'none', borderRadius: 5, padding: '5px 12px', fontWeight: 600, fontSize: 12, cursor: 'pointer' }} onClick={onSendNow}>Send Now</button>
        )}
      </div>
    </div>
  );
}
function VolunteerShiftEditor({ volunteer, roleQuotas, existingShifts, onSave, onClose }) {
  const [dayConfig, setDayConfig] = useState(() => {
    const map = {};
    (volunteer.days || []).forEach(day => {
      const existingForDay = existingShifts.filter(vs => vs.day === day);
      const hasFullDay = existingForDay.find(vs => vs.shift === 'Full Day');
      const am = existingForDay.find(vs => vs.shift === 'AM (9am-12pm)');
      const pm = existingForDay.find(vs => vs.shift === 'PM (1pm-4pm)');
      if (hasFullDay) {
        map[day] = { mode: 'Full Day', fullDayRole: hasFullDay.role || '', amRole: '', pmRole: '' };
      } else {
        map[day] = { mode: 'Split', fullDayRole: '', amRole: am?.role || '', pmRole: pm?.role || '' };
      }
    });
    return map;
  });

  const updateMode = (day, mode) => setDayConfig(prev => ({ ...prev, [day]: { ...prev[day], mode } }));
  const updateRole = (day, field, value) => setDayConfig(prev => ({ ...prev, [day]: { ...prev[day], [field]: value } }));

    const save = () => {
    const assignments = [];
    Object.entries(dayConfig).forEach(([day, cfg]) => {
      if (cfg.mode === 'Full Day') {
        if (cfg.fullDayRole) assignments.push({ day, shift: 'Full Day', role: cfg.fullDayRole });
      } else {
        if (cfg.amRole) assignments.push({ day, shift: 'AM (9am-12pm)', role: cfg.amRole });
        if (cfg.pmRole) assignments.push({ day, shift: 'PM (1pm-4pm)', role: cfg.pmRole });
      }
    });
    onSave(assignments);
  };

  const roleOptionsFor = () => (
    <>
      <option value="">— No role —</option>
      <option value="UNAVAILABLE">🚫 Unavailable</option>
      {eventRoles.map(rq => <option key={rq.role_name} value={rq.role_name}>{rq.role_name}</option>)}
    </>
  );
  
  const eventRoles = roleQuotas.filter(rq => rq.event === volunteer.event);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 480, maxHeight: '85vh', overflowY: 'auto' }}>
        <h3 style={{ ...s.h3, marginTop: 0 }}>Shifts — {volunteer.first_name} {volunteer.last_name}</h3>
        {(volunteer.days || []).map(day => {
          const cfg = dayConfig[day] || { mode: 'Split', fullDayRole: '', amRole: '', pmRole: '' };
          return (
            <div key={day} style={{ marginBottom: 18, paddingBottom: 14, borderBottom: '1px solid #eee' }}>
              <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 8 }}>{day}</div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                {['Full Day', 'Split'].map(m => (
                  <button
                    key={m}
                    onClick={() => updateMode(day, m)}
                    style={{ ...s.btnSecondary, fontSize: 12, padding: '5px 12px', background: cfg.mode === m ? '#4fc3c3' : '#f0f0f0', color: cfg.mode === m ? '#1a1a1a' : '#666' }}
                  >
                    {m === 'Full Day' ? 'Full Day' : 'Split AM/PM'}
                  </button>
                ))}
              </div>
              {cfg.mode === 'Full Day' ? (
                                <select
                  value={cfg.fullDayRole}
                  onChange={e => updateRole(day, 'fullDayRole', e.target.value)}
                  style={{ width: '100%', fontSize: 12, padding: '6px 8px', border: '1px solid #ddd', borderRadius: 5, color: cfg.fullDayRole === 'UNAVAILABLE' ? '#e74c3c' : '#1a1a1a' }}
                >
                  {roleOptionsFor()}
                </select>
              ) : (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                    <span style={{ fontSize: 12, width: 34, flexShrink: 0, color: '#666' }}>AM</span>
                                        <select
                      value={cfg.amRole}
                      onChange={e => updateRole(day, 'amRole', e.target.value)}
                      style={{ flex: 1, fontSize: 12, padding: '5px 8px', border: '1px solid #ddd', borderRadius: 5, color: cfg.amRole === 'UNAVAILABLE' ? '#e74c3c' : '#1a1a1a' }}
                    >
                      {roleOptionsFor()}
                    </select>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 12, width: 34, flexShrink: 0, color: '#666' }}>PM</span>
                                        <select
                      value={cfg.pmRole}
                      onChange={e => updateRole(day, 'pmRole', e.target.value)}
                      style={{ flex: 1, fontSize: 12, padding: '5px 8px', border: '1px solid #ddd', borderRadius: 5, color: cfg.pmRole === 'UNAVAILABLE' ? '#e74c3c' : '#1a1a1a' }}
                    >
                      {roleOptionsFor()}
                    </select>
                  </div>
                </>
              )}
            </div>
          );
        })}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
          <button style={{ ...s.btnSecondary, background: '#f0f0f0', color: '#666' }} onClick={onClose}>Cancel</button>
          <button style={s.btnPrimary} onClick={() => { save(); onClose(); }}>Save Shifts</button>
        </div>
      </div>
    </div>
  );
}
function EditRecordModal({ record, type, token, onClose, onSaved }) {
  const [f, setF] = useState({
    firstName: record.first_name || '',
    lastName: record.last_name || '',
    email: record.email || '',
    phone: record.phone || '',
    days: record.days || [],
    status: record.status || 'Registered',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const u = (k, v) => setF(p => ({ ...p, [k]: v }));
  const ev = EVENTS[record.event];

  const save = async () => {
    if (!f.firstName || !f.lastName || !f.email) { setError('Name and email are required.'); return; }
    setSaving(true);
    try {
      const res = await fetch(`${API}/api/${type}/${record.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'x-admin-token': token },
        body: JSON.stringify(f),
      });
      if (!res.ok) throw new Error();
      onSaved();
      onClose();
    } catch { setError('Save failed. Please try again.'); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 420, maxHeight: '85vh', overflowY: 'auto' }}>
        <h3 style={{ ...s.h3, marginTop: 0, fontSize: 18 }}>Edit {type === 'athletes' ? 'Athlete' : 'Volunteer'}</h3>
        {error && <div style={s.alert('error')}>{error}</div>}
        <div style={s.grid2}>
          <F label="First Name" req><Inp value={f.firstName} onChange={e => u('firstName', e.target.value)} /></F>
          <F label="Last Name" req><Inp value={f.lastName} onChange={e => u('lastName', e.target.value)} /></F>
        </div>
        <F label="Email" req><Inp value={f.email} onChange={e => u('email', e.target.value)} /></F>
        <F label="Phone"><Inp value={f.phone} onChange={e => u('phone', e.target.value)} /></F>
        <F label="Days">
          <CheckList opts={ev.days} selected={f.days} onChange={v => u('days', v)} cols={1} />
        </F>
        <F label="Status">
          <select style={s.select} value={f.status} onChange={e => u('status', e.target.value)}>
            {['Registered', 'Checked In', 'Waitlisted', 'Cancelled'].map(st => <option key={st}>{st}</option>)}
          </select>
        </F>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
          <button style={{ ...s.btnSecondary, background: '#f0f0f0', color: '#666' }} onClick={onClose}>Cancel</button>
          <button style={{ ...s.btnPrimary, opacity: saving ? 0.6 : 1 }} onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save Changes'}</button>
        </div>
      </div>
    </div>
  );
}
// ─── Communications Tab ────────────────────────────────────────────────────
function CommunicationsTab({ token, evFilter }) {
  const h = { 'x-admin-token': token };
  const [view, setView] = useState('list');
  const [step, setStep] = useState(1);
  const [recipientMode, setRecipientMode] = useState('group');
  const [filters, setFilters] = useState({ to: 'all', event: 'ALL', day: '', role: '', groupId: '' });
  const [allPeople, setAllPeople] = useState([]);
  const [loadingPeople, setLoadingPeople] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [peopleSearch, setPeopleSearch] = useState('');
  const [recipientPreview, setRecipientPreview] = useState([]);
  const [loadingR, setLoadingR] = useState(false);
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [scheduledFor, setScheduledFor] = useState('');
  const [includeRegBtn, setIncludeRegBtn] = useState(false);
  const [regBtnUrl, setRegBtnUrl] = useState('https://anthrosfoundation.org/pages/michigan');
  const [templateName, setTemplateName] = useState('');
  const [templates, setTemplates] = useState([]);
  const [comms, setComms] = useState([]);
  const [groups, setGroups] = useState([]);
  const [roles, setRoles] = useState([]);
  const [sending, setSending] = useState(false);
  const [alert, setAlert] = useState('');

  const loadComms = useCallback(async () => { try { const r = await fetch(`${API}/api/communications`, { headers: h }); if (r.ok) setComms(await r.json()); } catch {} }, [token]);
  const loadTemplates = useCallback(async () => { try { const r = await fetch(`${API}/api/templates`, { headers: h }); if (r.ok) setTemplates(await r.json()); } catch {} }, [token]);
  const loadGroups = useCallback(async () => { try { const r = await fetch(`${API}/api/groups`, { headers: h }); if (r.ok) setGroups(await r.json()); } catch {} }, [token]);
  const loadRoles = useCallback(async () => { try { const r = await fetch(`${API}/api/volunteers/roles-summary`, { headers: h }); if (r.ok) { const d = await r.json(); setRoles(d.roles || []); } } catch {} }, [token]);
  const loadAllPeople = useCallback(async () => {
    setLoadingPeople(true);
    try {
      const headers = { 'x-admin-token': token };
      const [ar, vr] = await Promise.all([
        fetch(`${API}/api/athletes`, { headers }).then(r => r.json()),
        fetch(`${API}/api/volunteers`, { headers }).then(r => r.json()),
      ]);
      setAllPeople([
        ...ar.map(x => ({ ...x, type: 'athlete' })),
        ...vr.map(x => ({ ...x, type: 'volunteer' })),
      ]);
    } catch (e) {
      console.error('Failed to load people:', e);
    }
    setLoadingPeople(false);
  }, [token]);

  useEffect(() => { loadComms(); loadTemplates(); loadGroups(); loadRoles(); }, []);
  useEffect(() => { if (recipientMode === 'individual') loadAllPeople(); }, [recipientMode]);

  const previewRecipients = useCallback(async () => {
    setLoadingR(true);
    try {
      const p = new URLSearchParams({ to: filters.to, event: filters.event, ...(filters.day && { day: filters.day }), ...(filters.role && { role: filters.role }), ...(filters.groupId && { group_id: filters.groupId }) });
      const r = await fetch(`${API}/api/communications/recipients?${p}`, { headers: h });
      if (r.ok) setRecipientPreview(await r.json());
    } catch {}
    setLoadingR(false);
  }, [filters, token]);

  useEffect(() => { if (recipientMode === 'group') previewRecipients(); }, [filters, recipientMode]);

  const recipientCount = recipientMode === 'group' ? recipientPreview.length : selectedIds.length;

  const filteredPeople = () => !peopleSearch ? allPeople : allPeople.filter(p => `${p.first_name} ${p.last_name} ${p.email}`.toLowerCase().includes(peopleSearch.toLowerCase()));
  const togglePerson = (id) => setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const toggleAll = () => {
    const fp = filteredPeople();
    const allSelected = fp.every(p => selectedIds.includes(p.id));
    setSelectedIds(prev => allSelected ? prev.filter(id => !fp.map(p => p.id).includes(id)) : [...new Set([...prev, ...fp.map(p => p.id)])]);
  };

  const loadTemplate = (t) => { setSubject(t.subject); setBody(t.body); };
  const saveTemplate = async () => {
    if (!templateName || !subject || !body) return;
    await fetch(`${API}/api/templates`, { method: 'POST', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ name: templateName, subject, body }) });
    setTemplateName(''); loadTemplates();
    setAlert('✓ Template saved!'); setTimeout(() => setAlert(''), 2500);
  };
  const deleteTemplate = async (id) => { await fetch(`${API}/api/templates/${id}`, { method: 'DELETE', headers: h }); loadTemplates(); };

  const send = async (schedule = false) => {
    if (!subject || !body || recipientCount === 0) return;
    setSending(true);
    try {
      const finalBody = includeRegBtn
      ? `${body}\n\n[REGISTER_BUTTON:${regBtnUrl}]`
      : body;
    const payload = { subject, body: finalBody, ...(schedule && scheduledFor ? { scheduled_for: scheduledFor } : {}), ...(recipientMode === 'individual' ? { individual_ids: selectedIds } : { to: filters.to, event: filters.event, day: filters.day, role: filters.role, group_id: filters.groupId }) };
      const r = await fetch(`${API}/api/communications/send`, { method: 'POST', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      const d = await r.json();
      setAlert(d.scheduled ? `🗓 Scheduled for ${new Date(scheduledFor).toLocaleString()} · ${d.recipientCount} recipients` : `✓ Sent to ${d.sent} recipients!`);
      setTimeout(() => { setAlert(''); setView('list'); setSubject(''); setBody(''); setScheduledFor(''); setSelectedIds([]); setStep(1); loadComms(); }, 3000);
    } catch { setAlert('Error sending. Please try again.'); }
    setSending(false);
  };

  const dayOptions = () => {
    if (filters.event === 'WI') return ['Friday, August 21st', 'Saturday, August 22nd'];
    if (filters.event === 'MI') return ['Thursday, July 23rd', 'Friday, July 24th'];
    return ['Friday, August 21st', 'Saturday, August 22nd', 'Thursday, July 23rd', 'Friday, July 24th'];
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ ...s.h2, margin: 0 }}>Communications</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={{ ...s.btnSmall, background: view === 'templates' ? '#1a1a1a' : '#e8f9f9', color: view === 'templates' ? '#fff' : '#1a1a1a' }} onClick={() => setView(view === 'templates' ? 'list' : 'templates')}>
            {view === 'templates' ? '← Back' : `📋 Templates (${templates.length})`}
          </button>
          {view === 'list' && <button style={s.btnPrimary} onClick={() => { setView('compose'); setStep(1); }}>+ Compose</button>}
        </div>
      </div>

      {alert && <div style={s.alert('success')}>{alert}</div>}

      {/* Templates */}
      {view === 'templates' && (
        <div style={s.card}>
          <h3 style={{ ...s.h3, marginTop: 0 }}>Saved Templates</h3>
          {templates.length === 0 && <div style={{ color: '#999', fontSize: 13 }}>No templates yet. Compose a message and save it as a template.</div>}
          {templates.map(t => (
            <div key={t.id} style={{ padding: '12px 0', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700 }}>{t.name}</div>
                <div style={{ fontSize: 13, color: '#666' }}>Subject: {t.subject}</div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>{t.body.slice(0, 100)}…</div>
              </div>
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <button style={s.btnSmall} onClick={() => { loadTemplate(t); setView('compose'); setStep(2); }}>Use</button>
                <button style={{ ...s.btnSmall, background: '#e74c3c', color: '#fff' }} onClick={() => deleteTemplate(t.id)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Compose */}
      {view === 'compose' && (
        <div style={s.card}>
          <div style={s.steps}>
            {['1. Recipients', '2. Message & Send'].map((lbl, i) => (
              <div key={lbl} style={s.step(i + 1 === step ? 'active' : i + 1 < step ? 'done' : '')} onClick={() => i + 1 < step && setStep(i + 1)}>
                {i + 1 < step ? '✓ ' : ''}{lbl}
              </div>
            ))}
          </div>

          {step === 1 && <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
              {[['group', '👥 Group Filter'], ['individual', '☑️ Individual Selection']].map(([mode, lbl]) => (
                <button key={mode} onClick={() => setRecipientMode(mode)} style={{ ...s.btnSecondary, flex: 1, fontSize: 13, background: recipientMode === mode ? '#4fc3c3' : '#f0f0f0', color: recipientMode === mode ? '#1a1a1a' : '#666' }}>{lbl}</button>
              ))}
            </div>

            {recipientMode === 'group' && <>
              <div style={s.grid2}>
                <F label="Participant Type">
                  <select style={s.select} value={filters.to} onChange={e => setFilters(p => ({ ...p, to: e.target.value }))}>
                    <option value="all">Athletes + Volunteers</option>
                    <option value="athletes">Athletes Only</option>
                    <option value="volunteers">Volunteers Only</option>
                    <option value="groups">Group Leaders Only</option>
                  </select>
                </F>
                <F label="Event">
                  <select style={s.select} value={filters.event} onChange={e => setFilters(p => ({ ...p, event: e.target.value, day: '' }))}>
                    <option value="ALL">Both Events</option>
                    <option value="WI">ATL – Wisconsin Only</option>
                    <option value="MI">ATL – Michigan Only</option>
                  </select>
                </F>
              </div>
              <div style={s.grid2}>
                <F label="Filter by Day">
                  <select style={s.select} value={filters.day} onChange={e => setFilters(p => ({ ...p, day: e.target.value }))}>
                    <option value="">All Days</option>
                    {dayOptions().map(d => <option key={d} value={d.split(',')[0]}>{d}</option>)}
                  </select>
                </F>
                {(filters.to === 'volunteers' || filters.to === 'all') && (
                  <F label="Filter by Role">
                    <select style={s.select} value={filters.role} onChange={e => setFilters(p => ({ ...p, role: e.target.value }))}>
                      <option value="">All Roles</option>
                      {[...new Set(roles.map(r => r.assigned_role))].filter(Boolean).sort().map(r => <option key={r} value={r}>{r}</option>)}
                    </select>
                  </F>
                )}
                {(filters.to === 'athletes' || filters.to === 'all') && (
                  <F label="Filter by Group">
                    <select style={s.select} value={filters.groupId} onChange={e => setFilters(p => ({ ...p, groupId: e.target.value }))}>
                      <option value="">All Groups</option>
                      {groups.map(g => <option key={g.id} value={g.id}>{g.group_name || g.organization}</option>)}
                    </select>
                  </F>
                )}
              </div>
              <div style={{ background: '#f0f9ff', border: '1.5px solid #4fc3c3', borderRadius: 7, padding: '10px 14px', fontSize: 13 }}>
                {loadingR ? 'Loading…' : <><strong>{recipientPreview.length}</strong> recipients match your filters</>}
              </div>
            </>}

            {recipientMode === 'individual' && <>
              <div style={{ display: 'flex', gap: 8, marginBottom: 10, alignItems: 'center' }}>
                <input placeholder="Search name or email…" value={peopleSearch} onChange={e => setPeopleSearch(e.target.value)} style={{ ...s.input, flex: 1 }} />
                <button style={s.btnSmall} onClick={toggleAll} disabled={loadingPeople}>{filteredPeople().every(p => selectedIds.includes(p.id)) ? 'Deselect All' : 'Select All'}</button>
                <button style={{ ...s.btnSmall, background: '#f0f0f0', color: '#1a1a1a' }} onClick={loadAllPeople} disabled={loadingPeople}>{loadingPeople ? '⟳' : '↺ Refresh'}</button>
              </div>
              {loadingPeople && <div style={{ textAlign: 'center', padding: 20, color: '#999', fontSize: 13 }}>Loading participants…</div>}
              {!loadingPeople && allPeople.length === 0 && (
                <div style={{ textAlign: 'center', padding: 20, color: '#999', fontSize: 13 }}>
                  No participants found. Make sure athletes or volunteers are registered, then click ↺ Refresh.
                </div>
              )}
              {!loadingPeople && allPeople.length > 0 && (
                <div style={{ maxHeight: 300, overflowY: 'auto', border: '1.5px solid #eee', borderRadius: 8 }}>
                  {filteredPeople().map(p => (
                    <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', borderBottom: '1px solid #f5f5f5', cursor: 'pointer', background: selectedIds.includes(p.id) ? '#f0f9ff' : '#fff' }}>
                      <input type="checkbox" checked={selectedIds.includes(p.id)} onChange={() => togglePerson(p.id)} />
                      <div style={{ flex: 1 }}>
                        <span style={{ fontWeight: 600, fontSize: 13 }}>{p.first_name} {p.last_name}</span>
                        <span style={{ ...s.tag(p.type === 'athlete' ? '#e8f9f9' : '#f0f0f0'), marginLeft: 6 }}>{p.type}</span>
                        <span style={s.tag('#f5f5f5')}>ATL–{p.event}</span>
                      </div>
                      <div style={{ fontSize: 12, color: '#888' }}>{p.email}</div>
                    </label>
                  ))}
                </div>
              )}
              <div style={{ background: '#f0f9ff', border: '1.5px solid #4fc3c3', borderRadius: 7, padding: '10px 14px', fontSize: 13, marginTop: 10 }}>
                <strong>{selectedIds.length}</strong> recipients selected
              </div>
            </>}
          </>}

          {step === 2 && <>
            {templates.length > 0 && (
              <F label="Load a Template">
                <select style={s.select} defaultValue="" onChange={e => { const t = templates.find(x => x.id === e.target.value); if (t) loadTemplate(t); }}>
                  <option value="">— Select a template —</option>
                  {templates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                </select>
              </F>
            )}
            <F label="Subject" req><Inp value={subject} onChange={e => setSubject(e.target.value)} placeholder="e.g. Important update for your upcoming event..." /></F>
            <F label="Message Body" req>
              <textarea style={{ ...s.textarea, minHeight: 180 }} value={body} onChange={e => setBody(e.target.value)} placeholder={'Write your message here...\n\nTip: Use {{firstName}} to personalize — e.g. "Hi {{firstName}}, we can\'t wait to see you!"'} />
            </F>

            {/* Save as template */}
            <div style={{ background: '#f9f9f9', border: '1.5px solid #eee', borderRadius: 8, padding: 14, marginBottom: 12 }}>
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8 }}>💾 Save as Template</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <Inp value={templateName} onChange={e => setTemplateName(e.target.value)} placeholder="Template name e.g. 'Welcome Email'" style={{ flex: 1 }} />
                <button style={s.btnSmall} onClick={saveTemplate} disabled={!templateName || !subject || !body}>Save</button>
              </div>
            </div>

            {/* Registration button option */}
            <div style={{ background: '#f9f9f9', border: '1.5px solid #eee', borderRadius: 8, padding: 14, marginBottom: 12 }}>
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8 }}>🔗 Include Registration Button</div>
              <div style={s.checkRow}>
                <input type="checkbox" id="includeBtn" checked={includeRegBtn} onChange={e => setIncludeRegBtn(e.target.checked)} />
                <label htmlFor="includeBtn" style={{ fontSize: 13, cursor: 'pointer' }}>Add a "Register Now →" button to the bottom of this email</label>
              </div>
              {includeRegBtn && (
                <div style={{ marginTop: 8 }}>
                  <label style={s.label}>Button URL</label>
                  <Inp value={regBtnUrl} onChange={e => setRegBtnUrl(e.target.value)} placeholder="https://atl-event-platform.onrender.com" />
                </div>
              )}
            </div>
            <div style={{ background: '#f9f9f9', border: '1.5px solid #eee', borderRadius: 8, padding: 14, marginBottom: 12 }}>
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8 }}>🗓 Schedule Send (Optional)</div>
              <Inp type="datetime-local" value={scheduledFor} onChange={e => setScheduledFor(e.target.value)} />
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Leave blank to send immediately. Scheduled messages must be manually triggered from the message history.</div>
            </div>
            {body && (
               <div style={{ marginBottom: 20 }}>
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, color: '#666' }}>📧 Live Preview</div>
              <div style={{ background: '#f0f0f0', borderRadius: 10, padding: 16 }}>
              <div style={{ background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,.08)', maxWidth: 480, margin: '0 auto' }}>
                <div style={{ background: '#1a1a1a', padding: '18px', textAlign: 'center' }}>
                 <div style={{ color: '#4fc3c3', fontWeight: 800, fontSize: 17, letterSpacing: 1 }}>AT THE LAKE</div>
                 <div style={{ color: '#999', fontSize: 9, letterSpacing: 2, textTransform: 'uppercase', marginTop: 2 }}>Anthros Foundation</div>
              </div>
        <div style={{ padding: '20px 18px' }} dangerouslySetInnerHTML={{ __html: renderEmailPreviewHtml(body) }} />
        <div style={{ background: '#f5f5f5', padding: 12, textAlign: 'center', fontSize: 10, color: '#888' }}>
          Anthros Foundation · anthrosfoundation.org
        </div>
      </div>
    </div>
  </div>
)}
            <div style={{ background: '#f0f9ff', border: '1.5px solid #4fc3c3', borderRadius: 7, padding: '10px 14px', fontSize: 13, marginBottom: 4 }}>
              Ready to send to <strong>{recipientCount}</strong> recipient{recipientCount !== 1 ? 's' : ''}
            </div>
          </>}

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
            <div style={{ display: 'flex', gap: 8 }}>
              {step > 1 && <button style={s.btnSecondary} onClick={() => setStep(p => p - 1)}>← Back</button>}
              <button style={{ ...s.btnSecondary, background: '#f0f0f0', color: '#666' }} onClick={() => { setView('list'); setStep(1); }}>Cancel</button>
            </div>
            {step === 1 && <button style={{ ...s.btnPrimary, opacity: recipientCount === 0 ? 0.5 : 1 }} onClick={() => recipientCount > 0 && setStep(2)}>Next: Message →</button>}
            {step === 2 && (
              <div style={{ display: 'flex', gap: 8 }}>
                {scheduledFor && <button style={{ ...s.btnSecondary, background: '#8e44ad', color: '#fff' }} onClick={() => send(true)} disabled={sending}>🗓 Schedule</button>}
                <button style={{ ...s.btnPrimary, opacity: (!subject || !body || sending) ? 0.5 : 1 }} onClick={() => send(false)} disabled={!subject || !body || sending}>
                  {sending ? 'Sending…' : `Send Now to ${recipientCount} →`}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {view === 'list' && (
        <div style={s.card}>
          <h3 style={{ ...s.h3, marginTop: 0 }}>Message History ({comms.length})</h3>
          {comms.length === 0 && <div style={{ color: '#999', fontSize: 13 }}>No messages sent yet.</div>}
          {comms.map(c => (
            <CommMessage key={c.id} c={c} h={h} onSendNow={async () => { await fetch(`${API}/api/communications/${c.id}/send-now`, { method: 'POST', headers: h }); loadComms(); }} />
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Import Tab ────────────────────────────────────────────────────────────
function ImportTab({ token }) {
  const h = { 'x-admin-token': token };
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState([]);
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);
  const [historical, setHistorical] = useState([]);
  const [activeView, setActiveView] = useState('upload');
  const [search, setSearch] = useState('');
  const [volunteerFilters, setVolunteerFilters] = useState({ name: '', email: '', event: '', day: '', role: '', assignedRole: '', shift: '', status: '' });
  const [athleteFilters, setAthleteFilters] = useState({ name: '', email: '', event: '', day: '', group: '', status: '' });
  const loadHistorical = useCallback(async () => {
    try { const r = await fetch(`${API}/api/imports/historical`, { headers: h }); if (r.ok) setHistorical(await r.json()); } catch {}
  }, [token]);

  useEffect(() => { loadHistorical(); }, []);

  const parseCSV = (text) => {
    const lines = text.split('\n').filter(l => l.trim());
    if (!lines.length) return [];
    const headers = lines[0].split(',').map(h => h.trim().replace(/^"|"$/g, ''));
    return lines.slice(1).map(line => {
      const values = [];
      let cur = '', inQ = false;
      for (const ch of line) {
        if (ch === '"') inQ = !inQ;
        else if (ch === ',' && !inQ) { values.push(cur.trim()); cur = ''; }
        else cur += ch;
      }
      values.push(cur.trim());
      return headers.reduce((obj, h, i) => ({ ...obj, [h]: values[i] || '' }), {});
    });
  };

  const handleFile = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f); setResult(null);
    const reader = new FileReader();
    reader.onload = (ev) => { const rows = parseCSV(ev.target.result); setPreview(rows.slice(0, 5)); };
    reader.readAsText(f);
  };

  const importFile = async () => {
    if (!file) return;
    setImporting(true);
    const reader = new FileReader();
    reader.onload = async (ev) => {
      const records = parseCSV(ev.target.result);
      try {
        const r = await fetch(`${API}/api/imports`, { method: 'POST', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ records, year: 2025 }) });
        const d = await r.json();
        setResult(d); loadHistorical();
      } catch { setResult({ error: 'Import failed. Please try again.' }); }
      setImporting(false);
    };
    reader.readAsText(file);
  };

  const filteredHistorical = !search ? historical : historical.filter(r => `${r.first_name} ${r.last_name} ${r.email}`.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['upload', '📤 Import CSV'], ['historical', `📋 Historical Records (${historical.length})`]].map(([v, lbl]) => (
          <button key={v} style={{ ...s.btnSecondary, background: activeView === v ? '#4fc3c3' : '#f0f0f0', color: activeView === v ? '#1a1a1a' : '#666' }} onClick={() => setActiveView(v)}>{lbl}</button>
        ))}
      </div>

      {activeView === 'upload' && (
        <div style={s.card}>
          <h3 style={{ ...s.h3, marginTop: 0 }}>Import 2025 Data</h3>
          <div style={{ background: '#f0f9ff', border: '1.5px solid #4fc3c3', borderRadius: 7, padding: 14, marginBottom: 16, fontSize: 13, lineHeight: 1.6 }}>
            <strong>Expected CSV columns:</strong> first name, last name, email, participant type, role (optional), event (optional).<br />
            Records matching a current 2026 email will be flagged as <span style={s.badge('#27ae60')}>🔄 Returning</span>
          </div>
          <F label="Select CSV File">
            <input type="file" accept=".csv,.xlsx" onChange={handleFile} style={{ padding: 8, border: '1.5px solid #ddd', borderRadius: 7, width: '100%', boxSizing: 'border-box' }} />
          </F>

          {preview.length > 0 && <>
            <h3 style={s.h3}>Preview (first {preview.length} rows)</h3>
            <div style={{ overflowX: 'auto', marginBottom: 16 }}>
              <table style={{ ...s.th, fontSize: 12, width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr>{Object.keys(preview[0]).map(k => <th key={k} style={s.th}>{k}</th>)}</tr></thead>
                <tbody>{preview.map((row, i) => <tr key={i}>{Object.values(row).map((v, j) => <td key={j} style={s.td}>{v}</td>)}</tr>)}</tbody>
              </table>
            </div>
            <button style={s.btnPrimary} onClick={importFile} disabled={importing}>{importing ? 'Importing…' : 'Import All Records →'}</button>
          </>}

          {result && (
            <div style={{ ...s.alert(result.error ? 'error' : 'success'), marginTop: 16 }}>
              {result.error ? result.error : <>✓ Import complete: <strong>{result.imported}</strong> records · <strong>{result.returning}</strong> returning · <strong>{result.skipped}</strong> skipped</>}
            </div>
          )}
        </div>
      )}

      {activeView === 'historical' && <>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
          <input placeholder="Search name or email…" value={search} onChange={e => setSearch(e.target.value)} style={{ ...s.input, maxWidth: 280 }} />
          <span style={s.tag('#e8f9f9')}>{historical.filter(r => r.is_returning).length} returning 🔄</span>
          <span style={s.tag('#f0f0f0')}>{historical.filter(r => !r.is_returning).length} not yet registered</span>
        </div>
        <div style={{ ...s.card, padding: 0, overflow: 'hidden' }}>
          <table>
            <thead><tr>{['Name', 'Email', 'Type', '2025 Role', 'Event', '2026 Status'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {filteredHistorical.length === 0 && <tr><td colSpan={6} style={{ ...s.td, textAlign: 'center', color: '#999' }}>No records yet.</td></tr>}
              {filteredHistorical.map(r => (
                <tr key={r.id}>
                  <td style={s.td}><strong>{r.first_name} {r.last_name}</strong></td>
                  <td style={s.td}>{r.email}</td>
                  <td style={s.td}><span style={s.tag()}>{r.participant_type || '—'}</span></td>
                  <td style={{ ...s.td, fontSize: 12 }}>{r.role || '—'}</td>
                  <td style={s.td}>{r.event || '—'}</td>
                  <td style={s.td}>{r.is_returning ? <span style={s.badge('#27ae60')}>🔄 Registered</span> : <span style={s.badge('#888')}>Not Yet</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>}
    </div>
  );
}

// ─── Admin Dashboard ───────────────────────────────────────────────────────
function AdminDashboard({ token, back }) {
  const [tab, setTab] = useState('overview');
  const [evFilter, setEvFilter] = useState('ALL');
  const [stats, setStats] = useState(null);
  const [athletes, setAthletes] = useState([]);
  const [volunteers, setVolunteers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [buddyData, setBuddyData] = useState({ buddies: [], unassigned: [] });
  const [roleQuotas, setRoleQuotas] = useState([]);
  const [comms, setComms] = useState([]);
  const [search, setSearch] = useState('');
  const [volunteerFilters, setVolunteerFilters] = useState({ name: '', email: '', event: '', day: '', role: '', assignedRole: '', shift: '', status: '' });
  const [athleteFilters, setAthleteFilters] = useState({ name: '', email: '', event: '', day: '', group: '', status: '' });
  const [editingRecord, setEditingRecord] = useState(null); // { record, type } or null 
  const [volunteerSort, setVolunteerSort] = useState({ key: 'first_name', dir: 'asc' });
  const [athleteSort, setAthleteSort] = useState({ key: 'first_name', dir: 'asc' });
  const [showAddRole, setShowAddRole] = useState(false);
  const [newRoleName, setNewRoleName] = useState('');
  const [newRoleQuota, setNewRoleQuota] = useState(1);
  const [adminUsers, setAdminUsers] = useState([]);
  const [newUserEmail, setNewUserEmail] = useState('');
  const [newUserPassword, setNewUserPassword] = useState('');
  const [capacities, setCapacities] = useState([]);
  const [waitlistEntries, setWaitlistEntries] = useState([]);
  const [volunteerShifts, setVolunteerShifts] = useState([]);
  const [expandedVolunteer, setExpandedVolunteer] = useState(null);
  const [compose, setCompose] = useState(false);
  const [msg, setMsg] = useState({ to: 'all', event: 'ALL', subject: '', body: '' });
  const [sending, setSending] = useState(false);
  const [sentAlert, setSentAlert] = useState('');
  const h = { 'x-admin-token': token };

  const load = useCallback(async (endpoint, setter, parser) => {
    try {
      const res = await fetch(`${API}${endpoint}`, { headers: h });
      if (res.ok) setter(parser ? (await res.json()).map ? (await res.json()) : await res.json() : await res.json());
    } catch {}
  }, [token]);

  const loadStats = useCallback(async () => {
    try { const r = await fetch(`${API}/api/admin/stats`, { headers: h }); if (r.ok) setStats(await r.json()); } catch {}
  }, [token]);

  const loadAthletes = useCallback(async () => {
    try { const r = await fetch(`${API}/api/athletes?event=${evFilter}`, { headers: h }); if (r.ok) setAthletes(await r.json()); } catch {}
  }, [token, evFilter]);

  const loadVolunteers = useCallback(async () => {
    try { const r = await fetch(`${API}/api/volunteers?event=${evFilter}`, { headers: h }); if (r.ok) setVolunteers(await r.json()); } catch {}
  }, [token, evFilter]);

  const loadGroups = useCallback(async () => {
    try { const r = await fetch(`${API}/api/groups?event=${evFilter}`, { headers: h }); if (r.ok) setGroups(await r.json()); } catch {}
  }, [token, evFilter]);

  const loadBuddies = useCallback(async () => {
    try { const r = await fetch(`${API}/api/buddies?event=${evFilter}`, { headers: h }); if (r.ok) setBuddyData(await r.json()); } catch {}
  }, [token, evFilter]);
  
  const loadRoleQuotas = useCallback(async () => {
  try { const r = await fetch(`${API}/api/role-quotas?event=${evFilter}`, { headers: h }); if (r.ok) setRoleQuotas(await r.json()); } catch {}
}, [token, evFilter]);

const updateQuota = async (id, quota) => {
  await fetch(`${API}/api/role-quotas/${id}`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ quota }) });
  loadRoleQuotas();
};
  const addRole = async () => {
  if (!newRoleName.trim()) return;
  const res = await fetch(`${API}/api/role-quotas`, {
    method: 'POST', headers: { ...h, 'Content-Type': 'application/json' },
    body: JSON.stringify({ event: evFilter, role_name: newRoleName.trim(), quota: parseInt(newRoleQuota, 10) || 1 }),
  });
  if (res.ok) {
    setNewRoleName(''); setNewRoleQuota(1); setShowAddRole(false);
    loadRoleQuotas();
  } else {
    const d = await res.json();
    alert(d.error || 'Failed to add role.');
  }
};
const printRoster = async () => {
  try {
    const res = await fetch(`${API}/api/role-quotas/export?event=${evFilter}`, { headers: h });
    if (!res.ok) { alert('Failed to generate roster. Please try again.'); return; }
    const html = await res.text();
    const blob = new Blob([html], { type: 'text/html' });
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
  } catch {
    alert('Failed to generate roster. Please try again.');
  }
};
const deleteRole = async (id, roleName) => {
  if (!window.confirm(`Remove "${roleName}"? This won't unassign any volunteers currently assigned this role — it'll just stop appearing as an option.`)) return;
  await fetch(`${API}/api/role-quotas/${id}`, { method: 'DELETE', headers: h });
  loadRoleQuotas();
};
  const updateRoleName = async (id, role_name) => {
  await fetch(`${API}/api/role-quotas/${id}`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ role_name }) });
  loadRoleQuotas();
};

const updateRoleDescription = async (id, description) => {
  await fetch(`${API}/api/role-quotas/${id}`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ description }) });
  loadRoleQuotas();
};
const loadAdminUsers = async () => {
  try { const r = await fetch(`${API}/api/admin-users`, { headers: h }); if (r.ok) setAdminUsers(await r.json()); } catch {}
};

const addAdminUser = async () => {
  if (!newUserEmail.trim() || !newUserPassword.trim()) return;
  const res = await fetch(`${API}/api/admin-users`, {
    method: 'POST', headers: { ...h, 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: newUserEmail.trim(), password: newUserPassword }),
  });
  if (res.ok) {
    setNewUserEmail(''); setNewUserPassword('');
    loadAdminUsers();
  } else {
    const d = await res.json();
    alert(d.error || 'Failed to add user.');
  }
};
const deleteAthlete = async (id, name) => {
  if (!window.confirm(`Permanently delete ${name}'s athlete registration? This cannot be undone and will remove them from all buddy assignments and check-in records.`)) return;
  await fetch(`${API}/api/athletes/${id}`, { method: 'DELETE', headers: h });
  loadAthletes();
  loadStats();
};

const deleteVolunteer = async (id, name) => {
  if (!window.confirm(`Permanently delete ${name}'s volunteer registration? This cannot be undone and will remove them from all shift assignments, buddy assignments, and check-in records.`)) return;
  await fetch(`${API}/api/volunteers/${id}`, { method: 'DELETE', headers: h });
  loadVolunteers();
  loadRoleQuotas();
  loadStats();
};
const deleteAdminUser = async (id, email) => {
  if (!window.confirm(`Remove access for ${email}?`)) return;
  await fetch(`${API}/api/admin-users/${id}`, { method: 'DELETE', headers: h });
  loadAdminUsers();
};
  const loadCapacities = async () => {
  if (evFilter === 'ALL') { setCapacities([]); return; }
  try { const r = await fetch(`${API}/api/capacity?event=${evFilter}`, { headers: h }); if (r.ok) setCapacities(await r.json()); } catch {}
};

const updateCapacity = async (id, max_capacity) => {
  await fetch(`${API}/api/capacity/${id}`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ max_capacity }) });
  loadCapacities();
};

const loadWaitlist = async () => {
  try { const r = await fetch(`${API}/api/waitlist?event=${evFilter}`, { headers: h }); if (r.ok) setWaitlistEntries(await r.json()); } catch {}
};

const deleteWaitlistEntry = async (id, name) => {
  if (!window.confirm(`Remove ${name} from the waitlist?`)) return;
  await fetch(`${API}/api/waitlist/${id}`, { method: 'DELETE', headers: h });
  loadWaitlist();
};
  const loadVolunteerShifts = async () => {
  try { const r = await fetch(`${API}/api/volunteer-shifts?event=${evFilter}`, { headers: h }); if (r.ok) setVolunteerShifts(await r.json()); } catch {}
};

const getShiftsFor = (volunteerId) => volunteerShifts.filter(vs => vs.volunteer_id === volunteerId);

const saveShiftsFor = async (volunteerId, event, assignments) => {
  await fetch(`${API}/api/volunteer-shifts/${volunteerId}`, {
    method: 'PUT', headers: { ...h, 'Content-Type': 'application/json' },
    body: JSON.stringify({ event, assignments }),
  });
  loadVolunteerShifts();
  loadRoleQuotas();
};
  const loadComms = useCallback(async () => {
    try { const r = await fetch(`${API}/api/communications`, { headers: h }); if (r.ok) setComms(await r.json()); } catch {}
  }, [token]);

  useEffect(() => { loadStats(); }, [loadStats]);
  useEffect(() => {
  if (tab === 'athletes') loadAthletes();
  if (tab === 'volunteers') { loadVolunteers(); loadRoleQuotas(); loadVolunteerShifts(); }
  if (tab === 'groups') loadGroups();
  if (tab === 'buddies') loadBuddies();
  if (tab === 'roles') loadRoleQuotas();
  if (tab === 'capacity') loadCapacities();
  if (tab === 'waitlist') loadWaitlist();
  if (tab === 'communications') loadComms();
  if (tab === 'users') loadAdminUsers();
}, [tab, evFilter]);

  const updateStatus = async (type, id, status) => {
    await fetch(`${API}/api/${type}/${id}/status`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ status }) });
    type === 'athletes' ? loadAthletes() : loadVolunteers();
    loadStats();
  };

  const assignRole = async (id, assignedRole, shift) => {
    await fetch(`${API}/api/volunteers/${id}/role`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ assignedRole, shift }) });
    loadVolunteers();
    if (tab === 'buddies') loadBuddies();
  };

  const assignBuddy = async (athleteId, buddyId) => {
    await fetch(`${API}/api/buddies/assign`, { method: 'POST', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ athleteId, buddyId, event: evFilter }) });
    loadBuddies();
  };
  const assignBuddyColor = async (volunteerId, color) => {
  await fetch(`${API}/api/volunteers/${volunteerId}/buddy-color`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ color }) });
  loadBuddies();
};
  const updateAdminNotes = async (id, admin_notes) => {
  await fetch(`${API}/api/volunteers/${id}/admin-notes`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ admin_notes }) });
  loadVolunteers();
};
  const exportCSV = async (type) => {
  try {
    const res = await fetch(`${API}/api/admin/export/${type}?event=${evFilter}`, { headers: h });
    if (!res.ok) { alert('Export failed. Please try again.'); return; }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${type}-${evFilter}-${new Date().toISOString().slice(0,10)}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Export error', err);
    alert('Export failed. Please try again.');
  }
};
const exportDayOf = async (type, day) => {
  try {
    const res = await fetch(`${API}/api/admin/export/day-of/${type}?event=${evFilter}&day=${encodeURIComponent(day)}`, { headers: h });
    if (!res.ok) { alert('Export failed. Please try again.'); return; }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${type}-${evFilter}-${day.replace(/[^a-z0-9]/gi, '-')}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch {
    alert('Export failed. Please try again.');
  }
};
  const sendComm = async () => {
    if (!msg.subject || !msg.body) return;
    setSending(true);
    try {
      const res = await fetch(`${API}/api/communications/send`, { method: 'POST', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify(msg) });
      const data = await res.json();
      setSentAlert(`✓ Sent to ${data.sent} recipients!`);
      setTimeout(() => { setSentAlert(''); setCompose(false); setMsg({ to: 'all', event: 'ALL', subject: '', body: '' }); loadComms(); }, 3000);
    } catch { setSentAlert('Error sending.'); }
    finally { setSending(false); }
  };

  const statusBadge = st => {
    const c = st === 'Registered' ? '#27ae60' : st === 'Checked In' ? '#2980b9' : st === 'Waitlisted' ? '#e67e22' : '#888';
    return <span style={s.badge(c)}>{st}</span>;
  };

  const dayOptionsForFilter = () => {          // ← add this
  if (evFilter === 'WI') return EVENTS.WI.days;
  if (evFilter === 'MI') return EVENTS.MI.days;
  return [...EVENTS.WI.days, ...EVENTS.MI.days];
};
  const sortVolunteers = (list) => {
  const { key, dir } = volunteerSort;
  const sorted = [...list].sort((a, b) => {
    let av, bv;
    if (key === 'assigned_role') { av = a.assigned_role || ''; bv = b.assigned_role || ''; }
    else { av = (a[key] || '').toString().toLowerCase(); bv = (b[key] || '').toString().toLowerCase(); }
    if (av < bv) return dir === 'asc' ? -1 : 1;
    if (av > bv) return dir === 'asc' ? 1 : -1;
    return 0;
  });
  return sorted;
};

const toggleVolunteerSort = (key) => {
  setVolunteerSort(prev => prev.key === key ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' });
};
const sortAthletes = (list) => {
  const { key, dir } = athleteSort;
  const sorted = [...list].sort((a, b) => {
    const av = (a[key] || '').toString().toLowerCase();
    const bv = (b[key] || '').toString().toLowerCase();
    if (av < bv) return dir === 'asc' ? -1 : 1;
    if (av > bv) return dir === 'asc' ? 1 : -1;
    return 0;
  });
  return sorted;
};

const toggleAthleteSort = (key) => {
  setAthleteSort(prev => prev.key === key ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' });
};

  const filteredVolunteers = () => {
  const filtered = volunteers.filter(v => {
    const matchName = !volunteerFilters.name || `${v.first_name} ${v.last_name}`.toLowerCase().includes(volunteerFilters.name.toLowerCase());
    const matchEmail = !volunteerFilters.email || (v.email || '').toLowerCase().includes(volunteerFilters.email.toLowerCase());
    const matchEvent = !volunteerFilters.event || v.event === volunteerFilters.event;
    const matchDay = !volunteerFilters.day || (v.days || []).includes(volunteerFilters.day);
    const matchRole = !volunteerFilters.role || (v.preferred_roles || []).some(r => r.toLowerCase().includes(volunteerFilters.role.toLowerCase()));
    const matchAssigned = !volunteerFilters.assignedRole || v.assigned_role === volunteerFilters.assignedRole;
    const matchShift = !volunteerFilters.shift || (v.shift || 'Full Day') === volunteerFilters.shift;
    const matchStatus = !volunteerFilters.status || v.status === volunteerFilters.status;
    return matchName && matchEmail && matchEvent && matchDay && matchRole && matchAssigned && matchShift && matchStatus;
  });
   return sortVolunteers(filtered);
};

const filteredAthletes = () => {
  const filtered = athletes.filter(a => {
    const matchName = !athleteFilters.name || `${a.first_name} ${a.last_name}`.toLowerCase().includes(athleteFilters.name.toLowerCase());
    const matchEmail = !athleteFilters.email || (a.email || '').toLowerCase().includes(athleteFilters.email.toLowerCase());
    const matchEvent = !athleteFilters.event || a.event === athleteFilters.event;
    const matchDay = !athleteFilters.day || (a.days || []).includes(athleteFilters.day);
    const matchGroup = !athleteFilters.group || (a.group_name || '').toLowerCase().includes(athleteFilters.group.toLowerCase());
    const matchStatus = !athleteFilters.status || a.status === athleteFilters.status;
    return matchName && matchEmail && matchEvent && matchDay && matchGroup && matchStatus;
  });
    return sortAthletes(filtered);
};

  const tabs = ['overview', 'athletes', 'volunteers', 'groups', 'buddies', 'roles', 'capacity', 'waitlist', 'check-in', 'communications', 'import', 'users'];

  return (
    <div style={{ ...s.app, background: '#f0f0f0' }}>
      <div style={{ ...s.header, position: 'sticky', top: 0 }}>
        <div><div style={s.logo}>AT THE LAKE — Admin</div><div style={s.logoSub}>Event Management Platform</div></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <select style={{ ...s.select, width: 180, fontSize: 13 }} value={evFilter} onChange={e => setEvFilter(e.target.value)}>
            <option value="ALL">All Events</option><option value="WI">ATL – Wisconsin</option><option value="MI">ATL – Michigan</option>
          </select>
          <button style={{ ...s.btnSecondary, fontSize: 13 }} onClick={back}>← Exit Admin</button>
        </div>
      </div>

      <div style={{ display: 'flex', background: '#fff', borderBottom: '2px solid #eee', paddingLeft: 24, overflowX: 'auto' }}>
        {tabs.map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ background: 'none', border: 'none', padding: '14px 16px', fontWeight: 700, fontSize: 12, cursor: 'pointer', color: tab === t ? '#4fc3c3' : '#666', borderBottom: tab === t ? '3px solid #4fc3c3' : '3px solid transparent', textTransform: 'capitalize', whiteSpace: 'nowrap' }}>{t}</button>
        ))}
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 16px' }}>

        {/* Overview */}
        {tab === 'overview' && stats && <>
          <h2 style={{ ...s.h2, marginBottom: 16 }}>Dashboard Overview</h2>
          <div style={{ ...s.grid4, marginBottom: 20 }}>
            {[['Total Athletes', stats.athleteTotal, '#4fc3c3'], ['Total Volunteers', stats.volunteerTotal, '#1a1a1a'], ['WI Registrations', stats.athleteWI + stats.volunteerWI, '#27ae60'], ['MI Registrations', stats.athleteMI + stats.volunteerMI, '#2980b9']].map(([l, n, c]) => (
              <div key={l} style={s.statCard}><div style={{ ...s.statCard, fontSize: 40, fontWeight: 800, color: c, padding: 0, boxShadow: 'none' }}>{n}</div><div style={{ fontSize: 13, color: '#666' }}>{l}</div></div>
            ))}
          </div>
          <div style={s.grid2}>
            <div style={s.card}>
              <h3 style={{ ...s.h3, marginTop: 0 }}>ATL – Wisconsin (Aug 21–22)</h3>
              <div style={{ fontSize: 13, color: '#666' }}>Athletes: <strong>{stats.athleteWI}</strong> / 75 per day cap</div>
              <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>Volunteers: <strong>{stats.volunteerWI}</strong></div>
              <div style={{ height: 8, background: '#eee', borderRadius: 4, marginTop: 10 }}>
                <div style={{ height: 8, background: '#4fc3c3', borderRadius: 4, width: `${Math.min(100, (stats.athleteWI / 75) * 100)}%` }} />
              </div>
              <div style={{ fontSize: 11, color: '#999', marginTop: 4 }}>{stats.athleteWI}/75 athlete spots filled</div>
            </div>
            <div style={s.card}>
              <h3 style={{ ...s.h3, marginTop: 0 }}>ATL – Michigan (Jul 23–24)</h3>
              <div style={{ fontSize: 13, color: '#666' }}>Athletes: <strong>{stats.athleteMI}</strong></div>
              <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>Volunteers: <strong>{stats.volunteerMI}</strong></div>
            </div>
          </div>
          <div style={s.card}>
            <h3 style={{ ...s.h3, marginTop: 0 }}>Recent Registrations</h3>
            {stats.recent?.length ? stats.recent.map(r => (
              <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                <div><strong>{r.first_name} {r.last_name}</strong><span style={{ ...s.tag(), marginLeft: 8 }}>{r.type}</span><span style={s.tag('#f0f0f0')}>ATL–{r.event}</span></div>
                <div style={{ fontSize: 12, color: '#999' }}>{new Date(r.submitted_at).toLocaleDateString()}</div>
              </div>
            )) : <div style={{ color: '#999', fontSize: 13 }}>No registrations yet.</div>}
          </div>
        </>}

        {/* Athletes */}
        {tab === 'athletes' && <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h2 style={{ ...s.h2, margin: 0 }}>Athletes ({filteredAthletes().length})</h2>
            <div style={{ display: 'flex', gap: 8 }}>
              <input placeholder="Search…" value={search} onChange={e => setSearch(e.target.value)} style={{ ...s.input, width: 220 }} />
              <button style={s.btnSmall} onClick={() => exportCSV('athletes')}>Export CSV</button>
{evFilter !== 'ALL' && dayOptionsForFilter().map(day => (
  <button key={day} style={{ ...s.btnSmall, background: '#1a1a1a', color: '#fff' }} onClick={() => exportDayOf('athletes', day)}>
    📋 {SHORT_DAY[day] || day} Check-In List
  </button>
))}
            </div>
          </div>
          <div style={{ ...s.card, padding: 0, overflowX: 'auto' }}>
            <table><thead>
  <tr>{[['Name', 'first_name'], ['Event', 'event'], ['Email', 'email'], ['Days', null], ['Roles', null], ['Shift & Role', null], ['Admin Notes', null], ['Status', 'status'], ['Actions', null]].map(([label, key]) => (
  <th key={label} onClick={() => key && toggleAthleteSort(key)} style={{ ...s.th, cursor: key ? 'pointer' : 'default', userSelect: 'none' }}>
    {label}{key && athleteSort.key === key ? (athleteSort.dir === 'asc' ? ' ▲' : ' ▼') : ''}
  </th>
))}</tr>
  <tr>
    <th style={s.filterTh}><input placeholder="Filter…" style={s.filterInput} value={athleteFilters.name} onChange={e => setAthleteFilters(p => ({ ...p, name: e.target.value }))} /></th>
    <th style={s.filterTh}>
  <select style={s.filterInput} value={athleteFilters.event} onChange={e => setAthleteFilters(p => ({ ...p, event: e.target.value }))}>
    <option value="">All</option>
    <option value="WI">ATL–WI</option>
    <option value="MI">ATL–MI</option>
  </select>
</th>
    <th style={s.filterTh}><input placeholder="Filter…" style={s.filterInput} value={athleteFilters.email} onChange={e => setAthleteFilters(p => ({ ...p, email: e.target.value }))} /></th>
    <th style={s.filterTh}>
      <select style={s.filterInput} value={athleteFilters.day} onChange={e => setAthleteFilters(p => ({ ...p, day: e.target.value }))}>
        <option value="">All</option>
        {dayOptionsForFilter().map(d => <option key={d} value={d}>{d}</option>)}
      </select>
    </th>
    <th style={s.filterTh}><input placeholder="Filter…" style={s.filterInput} value={athleteFilters.group} onChange={e => setAthleteFilters(p => ({ ...p, group: e.target.value }))} /></th>
    <th style={s.filterTh}></th>
<th style={s.filterTh}></th>
<th style={s.filterTh}>
  <select style={s.filterInput} value={athleteFilters.status} onChange={e => setAthleteFilters(p => ({ ...p, status: e.target.value }))}>
        <option value="">All</option>
        {['Registered', 'Checked In', 'Waitlisted', 'Cancelled'].map(st => <option key={st}>{st}</option>)}
      </select>
    </th>
    <th style={s.filterTh}></th>
  </tr>
</thead>
              <tbody>
                {filteredAthletes().length ? filteredAthletes().map(a => (
                  <tr key={a.id}>
                    <td style={s.td}><div style={{ fontWeight: 600 }}>{a.first_name} {a.last_name}</div>{a.has_guest ? <div style={{ fontSize: 11, color: '#888' }}>+ Guest: {a.guest_first} {a.guest_last}</div> : null}</td>
                    <td style={s.td}><span style={s.tag()}>ATL–{a.event}</span></td>
                    <td style={s.td}>{a.email}</td>
                    <td style={{ ...s.td, fontSize: 12, whiteSpace: 'nowrap' }}>{shortDays(a.days)}</td>
                    <td style={s.td}>{a.group_name ? <span style={s.tag('#f0e6ff')}>{a.group_name}</span> : <span style={{ color: '#ccc' }}>—</span>}</td>
                    <td style={s.td}>{a.buddy_first ? `${a.buddy_first} ${a.buddy_last}` : <span style={{ color: '#ccc' }}>Unassigned</span>}</td>
<td style={{ ...s.td, fontSize: 12, maxWidth: 180, minWidth: 140, whiteSpace: 'normal', paddingTop: 10, paddingRight: 16, lineHeight: 1.5 }}>{a.notes || a.special_needs ? [a.special_needs, a.notes].filter(Boolean).join(' — ') : <span style={{ color: '#ccc' }}>—</span>}</td>
<td style={s.td}>{statusBadge(a.status)}</td>
                    <td style={s.td}>
                      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                      <select style={{ fontSize: 12, padding: '3px 6px', border: '1px solid #ddd', borderRadius: 4 }} value={a.status} onChange={e => updateStatus('athletes', a.id, e.target.value)}>
                      {['Registered', 'Checked In', 'Waitlisted', 'Cancelled'].map(st => <option key={st}>{st}</option>)}
                      </select>
                     <button style={s.btnSmall} onClick={() => setEditingRecord({ record: a, type: 'athletes' })}>Edit</button>
<button style={{ ...s.btnSmall, background: '#e74c3c', color: '#fff' }} onClick={() => deleteAthlete(a.id, `${a.first_name} ${a.last_name}`)}>Delete</button>
                       </div>
                     </td>
                  </tr>
                )) : <tr><td colSpan={8} style={{ ...s.td, textAlign: 'center', color: '#999' }}>No athletes found.</td></tr>}
              </tbody>
            </table>
          </div>
        </>}

        {/* Volunteers */}
        {tab === 'volunteers' && <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h2 style={{ ...s.h2, margin: 0 }}>Volunteers ({filteredVolunteers().length})</h2>
            <div style={{ display: 'flex', gap: 8 }}>
              <input placeholder="Search…" value={search} onChange={e => setSearch(e.target.value)} style={{ ...s.input, width: 220 }} />
              <button style={s.btnSmall} onClick={() => exportCSV('volunteers')}>Export CSV</button>
{evFilter !== 'ALL' && dayOptionsForFilter().map(day => (
  <button key={day} style={{ ...s.btnSmall, background: '#1a1a1a', color: '#fff' }} onClick={() => exportDayOf('volunteers', day)}>
    📋 {SHORT_DAY[day] || day} Check-In List
  </button>
))}
            </div>
          </div>
          <div style={{ ...s.card, padding: 0, overflowX: 'auto' }}>
            <table><thead>
  <tr>{[['Name', 'first_name'], ['Event', 'event'], ['Email', 'email'], ['Days', null], ['Roles', null], ['Assigned', 'assigned_role'], ['Shift', 'shift'], ['Admin Notes', null], ['Status', 'status'], ['Actions', null]].map(([label, key]) => (
  <th key={label} onClick={() => key && toggleVolunteerSort(key)} style={{ ...s.th, padding: '7px 8px', fontSize: 12, cursor: key ? 'pointer' : 'default', userSelect: 'none' }}>
    {label}{key && volunteerSort.key === key ? (volunteerSort.dir === 'asc' ? ' ▲' : ' ▼') : ''}
  </th>
))}</tr>
  <tr>
    <th style={s.filterTh}><input placeholder="Filter…" style={s.filterInput} value={volunteerFilters.name} onChange={e => setVolunteerFilters(p => ({ ...p, name: e.target.value }))} /></th>
   <th style={{ ...s.filterTh, width: 70 }}>
<select style={{ ...s.filterInput, padding: '6px 4px', fontSize: 11 }} value={volunteerFilters.event} onChange={e => setVolunteerFilters(p => ({ ...p, event: e.target.value }))}>
  <option value="">All</option>
  <option value="WI">WI</option>
  <option value="MI">MI</option>
</select>
</th>
    <th style={{ ...s.filterTh, maxWidth: 140 }}><input placeholder="Filter…" style={s.filterInput} value={volunteerFilters.email} onChange={e => setVolunteerFilters(p => ({ ...p, email: e.target.value }))} /></th>
    <th style={s.filterTh}>
      <select style={s.filterInput} value={volunteerFilters.day} onChange={e => setVolunteerFilters(p => ({ ...p, day: e.target.value }))}>
        <option value="">All</option>
        {dayOptionsForFilter().map(d => <option key={d} value={d}>{d}</option>)}
      </select>
    </th>
    <th style={{ ...s.filterTh, maxWidth: 110 }}><input placeholder="Filter…" style={s.filterInput} value={volunteerFilters.role} onChange={e => setVolunteerFilters(p => ({ ...p, role: e.target.value }))} /></th>
   <th style={{ ...s.filterTh, maxWidth: 110 }}>
  <select style={s.filterInput} value={volunteerFilters.assignedRole} onChange={e => setVolunteerFilters(p => ({ ...p, assignedRole: e.target.value }))}>
        <option value="">All</option>
        {[...new Set(volunteers.map(v => v.assigned_role).filter(Boolean))].sort().map(r => <option key={r} value={r}>{r}</option>)}
      </select>
    </th>
    <th style={s.filterTh}>
  <select style={s.filterInput} value={volunteerFilters.shift} onChange={e => setVolunteerFilters(p => ({ ...p, shift: e.target.value }))}>
    <option value="">All</option>
    <option>Full Day</option><option>AM (9am-12pm)</option><option>PM (1pm-4pm)</option>
  </select>
</th>
<th style={s.filterTh}></th>
<th style={s.filterTh}>
  <select style={s.filterInput} value={volunteerFilters.status} onChange={e => setVolunteerFilters(p => ({ ...p, status: e.target.value }))}>
        <option value="">All</option>
        {['Registered', 'Checked In', 'Waitlisted', 'Cancelled'].map(st => <option key={st}>{st}</option>)}
      </select>
    </th>
    <th style={s.filterTh}></th>
  </tr>
</thead>
              <tbody>
                {filteredVolunteers().length ? filteredVolunteers().map(v => (
                  <tr key={v.id}>
                    <td style={s.td}><div style={{ fontWeight: 600 }}>{v.first_name} {v.last_name}</div></td>
                    <td style={s.td}><span style={s.tag('#f0f0f0')}>ATL–{v.event}</span></td>
                    <td style={s.td}>{v.email}</td>
                    <td style={{ ...s.td, fontSize: 12, whiteSpace: 'nowrap' }}>{shortDays(v.days)}</td>
                    <td style={{ ...s.td, fontSize: 12, maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={(v.preferred_roles || []).join(', ')}>{(v.preferred_roles || [])[0] || '—'}{(v.preferred_roles || []).length > 1 ? ` +${v.preferred_roles.length - 1}` : ''}</td>
                    <td style={{ ...s.td, minWidth: 160 }} colSpan={2}>
  {getShiftsFor(v.id).length ? getShiftsFor(v.id).map(vs => (
  <div key={vs.id} style={{ fontSize: 11, marginBottom: 2, color: vs.role === 'UNAVAILABLE' ? '#e74c3c' : '#1a1a1a' }}>
    <strong>{SHORT_DAY[vs.day] || vs.day} {vs.shift === 'Full Day' ? 'Full Day' : vs.shift.split(' ')[0]}:</strong> {vs.role === 'UNAVAILABLE' ? '🚫 Unavailable' : vs.role}
  </div>
)) : <div style={{ fontSize: 11, color: '#999' }}>No shifts assigned</div>}
  <button style={{ ...s.btnSmall, marginTop: 4, fontSize: 11 }} onClick={() => setExpandedVolunteer(v)}>Manage Shifts</button>
</td>
<td style={{ ...s.td, minWidth: 140 }}>
  <textarea
    defaultValue={v.admin_notes || ''}
    onBlur={e => { if (e.target.value !== (v.admin_notes || '')) updateAdminNotes(v.id, e.target.value); }}
    placeholder="e.g. Jet Ski #2, half day only..."
    style={{ width: '100%', fontSize: 11, padding: '4px 6px', border: '1px solid #eee', borderRadius: 4, minHeight: 32, resize: 'vertical', fontFamily: 'inherit' }}
  />
</td>
<td style={s.td}>
<div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                     <select style={{ fontSize: 12, padding: '3px 6px', border: '1px solid #ddd', borderRadius: 4 }} value={v.status} onChange={e => updateStatus('volunteers', v.id, e.target.value)}>
                      {['Registered', 'Checked In', 'Waitlisted', 'Cancelled'].map(st => <option key={st}>{st}</option>)}
                     </select>
                     <button style={s.btnSmall} onClick={() => setEditingRecord({ record: v, type: 'volunteers' })}>Edit</button>
<button style={{ ...s.btnSmall, background: '#e74c3c', color: '#fff' }} onClick={() => deleteVolunteer(v.id, `${v.first_name} ${v.last_name}`)}>Delete</button>
                    </div>
                    </td>
                  </tr>
                )) : <tr><td colSpan={9} style={{ ...s.td, textAlign: 'center', color: '#999' }}>No volunteers found.</td></tr>}
              </tbody>
            </table>
          </div>
        </>}

        {/* Groups */}
        {tab === 'groups' && <>
          <h2 style={{ ...s.h2, marginBottom: 16 }}>Groups & Day Programs ({groups.length})</h2>
          <div style={{ ...s.card, padding: 0, overflowX: 'auto' }}>
            <table><thead><tr>{['Group / Organization', 'Group Code', 'Event', 'Leader', 'Phone', 'Days', 'Expected', 'Registered', 'Checked In'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {groups.length ? groups.map(g => (
                  <tr key={g.id}>
                    <td style={s.td}><div style={{ fontWeight: 600 }}>{g.group_name || g.organization}</div><div style={{ fontSize: 11, color: '#888' }}>{g.organization}</div></td>
                    <td style={s.td}><span style={{ fontFamily: 'monospace', background: '#f0f0f0', padding: '2px 6px', borderRadius: 4, fontSize: 12 }}>{g.group_code}</span></td>
                    <td style={s.td}><span style={s.tag()}>ATL–{g.event}</span></td>
                    <td style={s.td}>{g.first_name} {g.last_name}<div style={{ fontSize: 11, color: '#888' }}>{g.email}</div></td>
                    <td style={s.td}>{g.phone}</td>
                    <td style={{ ...s.td, fontSize: 12 }}>{(g.days || []).join(', ')}</td>
                    <td style={s.td}>{g.expected_headcount}</td>
                    <td style={s.td}><strong>{g.actual_headcount || 0}</strong></td>
                    <td style={s.td}><span style={s.badge('#27ae60')}>{g.checked_in_count || 0}</span></td>
                  </tr>
                )) : <tr><td colSpan={9} style={{ ...s.td, textAlign: 'center', color: '#999' }}>No groups registered yet.</td></tr>}
              </tbody>
            </table>
          </div>
        </>}

        {/* Buddy Assignments */}
        {tab === 'buddies' && <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h2 style={{ ...s.h2, margin: 0 }}>Athlete Buddy Assignments</h2>
            <button style={s.btnSmall} onClick={() => window.open(`${API}/api/buddies/export?event=${evFilter}`, '_blank')}>Export Buddy Sheets</button>
          </div>

          {/* Unassigned athletes */}
          <div style={s.card}>
            <h3 style={{ ...s.h3, marginTop: 0, color: '#e67e22' }}>⚠ Unassigned Athletes ({buddyData.unassigned?.length || 0})</h3>
            {buddyData.unassigned?.length ? (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10 }}>
                {buddyData.unassigned.map(a => (
                  <div key={a.id} style={{ border: '1.5px solid #eee', borderRadius: 8, padding: 12 }}>
                    <div style={{ fontWeight: 700 }}>{a.first_name} {a.last_name}</div>
                    {a.group_name && <div style={{ fontSize: 11, color: '#888' }}>Group: {a.group_name}</div>}
                    <div style={{ fontSize: 11, color: '#666', marginTop: 4 }}>{(a.activities || []).slice(0, 3).join(', ')}</div>
                    <div style={{ marginTop: 8 }}>
                      <select style={{ fontSize: 12, padding: '4px 8px', border: '1px solid #ddd', borderRadius: 4, width: '100%' }}
                        defaultValue=""
                        onChange={e => e.target.value && assignBuddy(a.id, e.target.value)}>
                        <option value="">Assign to Buddy…</option>
                        {buddyData.buddies?.map(b => <option key={b.id} value={b.id}>{b.first_name} {b.last_name} ({b.athletes?.length || 0} athletes)</option>)}
                      </select>
                    </div>
                  </div>
                ))}
              </div>
            ) : <div style={{ color: '#999', fontSize: 13 }}>All athletes are assigned to a buddy!</div>}
          </div>

          {/* Buddy cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
            {buddyData.buddies?.length ? buddyData.buddies.map(b => (
              <div key={b.id} style={s.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
  <div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {b.buddy_color && <span style={{ width: 14, height: 14, borderRadius: '50%', background: b.buddy_color.toLowerCase(), border: '1.5px solid #ccc', flexShrink: 0 }} />}
      <div style={{ fontWeight: 800, fontSize: 16 }}>{b.first_name} {b.last_name}</div>
    </div>
    <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{b.shift || 'Full Day'} · ATL–{b.event}</div>
    <select
      value={b.buddy_color || ''}
      onChange={e => assignBuddyColor(b.id, e.target.value)}
      style={{ fontSize: 11, padding: '2px 5px', border: '1px solid #ddd', borderRadius: 4, marginTop: 4 }}
    >
      <option value="">— Visor Color —</option>
      {['Pink', 'Purple', 'Blue', 'Yellow', 'Green', 'White', 'Orange'].map(c => <option key={c} value={c}>{c}</option>)}
    </select>
  </div>
  <span style={{ ...s.badge('#4fc3c3'), color: '#1a1a1a' }}>{b.athletes?.length || 0} athletes</span>
</div>
                {b.athletes?.length ? b.athletes.map(a => (
  <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderTop: '1px solid #f0f0f0', gap: 8 }}>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 13, fontWeight: 600 }}>{a.first_name} {a.last_name}</div>
      {a.group_name && <div style={{ fontSize: 11, color: '#888' }}>{a.group_name}</div>}
      {a.special_needs && <div style={{ fontSize: 11, color: '#e74c3c' }}>⚠ {a.special_needs}</div>}
    </div>
    <select
      value={b.id}
      onChange={e => e.target.value !== b.id && assignBuddy(a.id, e.target.value)}
      style={{ fontSize: 11, padding: '3px 5px', border: '1px solid #ddd', borderRadius: 4, maxWidth: 110 }}
    >
      {buddyData.buddies?.map(bud => <option key={bud.id} value={bud.id}>{bud.first_name} {bud.last_name}</option>)}
    </select>
    <button onClick={() => assignBuddy(a.id, null)} style={{ background: 'none', border: 'none', color: '#ccc', cursor: 'pointer', fontSize: 16, flexShrink: 0 }}>✕</button>
  </div>
)) : <div style={{ fontSize: 13, color: '#999' }}>No athletes assigned yet.</div>}
              </div>
            )) : <div style={{ ...s.card, color: '#999', fontSize: 13 }}>No Athlete Buddies assigned yet. Assign volunteers the "Athlete Buddy" role in the Volunteers tab to populate this view.</div>}
          </div>
        </>}
{/* Role Quotas */}
        {tab === 'roles' && <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
  <h2 style={{ ...s.h2, margin: 0 }}>Volunteer Role Coverage {evFilter !== 'ALL' ? `— ATL–${evFilter}` : ''}</h2>
  {evFilter !== 'ALL' && (
  <div style={{ display: 'flex', gap: 8 }}>
    <button style={{ ...s.btnSmall, background: '#1a1a1a', color: '#fff' }} onClick={() => printRoster()}>🖨️ Print Roster</button>
    <button style={s.btnPrimary} onClick={() => setShowAddRole(v => !v)}>{showAddRole ? '✕ Cancel' : '+ Add Role'}</button>
  </div>
)}
</div>

{showAddRole && evFilter !== 'ALL' && (
  <div style={{ ...s.card, display: 'flex', gap: 10, alignItems: 'flex-end' }}>
    <div style={{ flex: 1 }}>
      <label style={s.label}>Role Name</label>
      <input style={s.input} value={newRoleName} onChange={e => setNewRoleName(e.target.value)} placeholder="e.g. Creative Cube Art Assistant" />
    </div>
    <div style={{ width: 100 }}>
      <label style={s.label}>Quota (per day)</label>
      <input type="number" min="0" style={s.input} value={newRoleQuota} onChange={e => setNewRoleQuota(e.target.value)} />
    </div>
    <button style={s.btnPrimary} onClick={addRole} disabled={!newRoleName.trim()}>Add</button>
  </div>
)}

          {evFilter !== 'ALL' && roleQuotas.length > 0 && (() => {
            const totalRoles = roleQuotas.length;
            const fullRoles = roleQuotas.filter(rq => rq.filled >= rq.quota).length;
            const totalSlots = roleQuotas.reduce((sum, rq) => sum + rq.quota, 0);
            const totalFilled = roleQuotas.reduce((sum, rq) => sum + rq.filled, 0);
            const totalNeeded = Math.max(0, totalSlots - totalFilled);
            return (
              <div style={{ ...s.grid4, marginBottom: 20 }}>
                {[
                  ['Roles Fully Staffed', `${fullRoles} / ${totalRoles}`, '#27ae60'],
                  ['Total Slots Needed', totalNeeded, '#e67e22'],
                  ['Total Volunteers Assigned', totalFilled, '#4fc3c3'],
                  ['Total Slots Overall', totalSlots, '#1a1a1a'],
                ].map(([l, n, c]) => (
                  <div key={l} style={s.statCard}>
                    <div style={{ ...s.statCard, fontSize: 32, fontWeight: 800, color: c, padding: 0, boxShadow: 'none' }}>{n}</div>
                    <div style={{ fontSize: 12, color: '#666' }}>{l}</div>
                  </div>
                ))}
              </div>
            );
          })()}

          {evFilter === 'ALL' && (
            <div style={{ ...s.card, color: '#999', fontSize: 13 }}>
              Please select a specific event (WI or MI) from the dropdown above to view role coverage — quotas are tracked per event.
            </div>
          )}

          {evFilter !== 'ALL' && roleQuotas.length === 0 && (
            <div style={{ ...s.card, color: '#999', fontSize: 13 }}>No role quotas set for this event yet.</div>
          )}

          {evFilter !== 'ALL' && roleQuotas.length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
              {roleQuotas.map(rq => {
  const days = dayOptionsForFilter();
  return (
    <div key={rq.id} style={s.card}>
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
  <div style={{ flex: 1 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <input
        defaultValue={rq.role_name}
        onBlur={e => { if (e.target.value.trim() && e.target.value.trim() !== rq.role_name) updateRoleName(rq.id, e.target.value.trim()); }}
        style={{ fontWeight: 800, fontSize: 15, border: 'none', borderBottom: '1.5px dashed transparent', background: 'transparent', padding: '2px 0', width: '100%' }}
        onFocus={e => e.target.style.borderBottomColor = '#4fc3c3'}
      />
      <button onClick={() => deleteRole(rq.id, rq.role_name)} style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: 15, lineHeight: 1, padding: 0, flexShrink: 0 }} title="Remove this role">✕</button>
    </div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
            Quota (per day):{' '}
            <input
              type="number"
              min="0"
              defaultValue={rq.quota}
              onBlur={e => {
                const v = parseInt(e.target.value, 10);
                if (!isNaN(v) && v !== rq.quota) updateQuota(rq.id, v);
              }}
                           style={{ width: 50, padding: '2px 5px', border: '1px solid #ddd', borderRadius: 4, fontSize: 12 }}
            />
          </div>
          <textarea
            defaultValue={rq.description || ''}
            onBlur={e => { if (e.target.value !== (rq.description || '')) updateRoleDescription(rq.id, e.target.value); }}
            placeholder="Add a short description of this role (used in volunteer emails)..."
            style={{ width: '100%', fontSize: 12, padding: '6px 8px', border: '1px solid #eee', borderRadius: 6, marginTop: 6, marginBottom: 4, minHeight: 50, resize: 'vertical', fontFamily: 'inherit' }}
          />
        </div>
      </div>

      {days.map(day => {
        const onThisDay = (rq.assignedVolunteers || []).filter(v => (v.days || []).includes(day));
        const remaining = rq.quota - onThisDay.length;
        const full = remaining <= 0;
        return (
          <div key={day} style={{ marginBottom: 10, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#555' }}>{day}</div>
              <span style={s.badge(full ? '#27ae60' : '#e67e22')}>{full ? 'Full' : `${remaining} needed`}</span>
            </div>
            {onThisDay.length ? onThisDay.map(v => (
              <div key={v.id} style={{ fontSize: 13, fontWeight: 600, padding: '3px 0' }}>{v.first_name} {v.last_name}</div>
            )) : <div style={{ fontSize: 12, color: '#999' }}>No one assigned for this day.</div>}
          </div>
        );
      })}
    </div>
  );
})}
            </div>
          )}
        </>}
{/* Capacity */}
{tab === 'capacity' && <>
  <h2 style={{ ...s.h2, marginBottom: 16 }}>Day Capacity {evFilter !== 'ALL' ? `— ATL–${evFilter}` : ''}</h2>
  {evFilter === 'ALL' ? (
    <div style={{ ...s.card, color: '#999', fontSize: 13 }}>Please select a specific event (WI or MI) from the dropdown above to manage capacity.</div>
  ) : (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
      {capacities.map(c => (
        <div key={c.id} style={s.card}>
          <div style={{ fontWeight: 800, fontSize: 15, marginBottom: 8 }}>{c.day}</div>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>
            <strong>{c.current}</strong> registered / max{' '}
            <input
              type="number"
              min="0"
              defaultValue={c.max_capacity}
              onBlur={e => {
                const v = parseInt(e.target.value, 10);
                if (!isNaN(v) && v !== c.max_capacity) updateCapacity(c.id, v);
              }}
              style={{ width: 60, padding: '3px 6px', border: '1px solid #ddd', borderRadius: 4, fontSize: 13 }}
            />
          </div>
          <span style={s.badge(c.full ? '#e74c3c' : '#27ae60')}>{c.full ? 'FULL' : `${c.max_capacity - c.current} spots open`}</span>
        </div>
      ))}
    </div>
  )}
</>}

{/* Waitlist */}
{tab === 'waitlist' && <>
  <h2 style={{ ...s.h2, marginBottom: 16 }}>Waitlist {evFilter !== 'ALL' ? `— ATL–${evFilter}` : ''} ({waitlistEntries.length})</h2>
  <div style={{ ...s.card, padding: 0, overflowX: 'auto' }}>
    <table>
      <thead><tr>{['Name', 'Email', 'Phone', 'Day', 'Notes', 'Submitted', ''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
      <tbody>
        {waitlistEntries.length ? waitlistEntries.map(w => (
          <tr key={w.id}>
            <td style={s.td}>{w.first_name} {w.last_name}</td>
            <td style={s.td}>{w.email}</td>
            <td style={s.td}>{w.phone || '—'}</td>
            <td style={s.td}>{w.day || '—'}</td>
            <td style={{ ...s.td, maxWidth: 200, whiteSpace: 'normal' }}>{w.notes || '—'}</td>
            <td style={s.td}>{new Date(w.submitted_at).toLocaleDateString()}</td>
            <td style={s.td}><button onClick={() => deleteWaitlistEntry(w.id, `${w.first_name} ${w.last_name}`)} style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: 13 }}>Remove</button></td>
          </tr>
        )) : <tr><td colSpan={7} style={{ ...s.td, textAlign: 'center', color: '#999' }}>No one on the waitlist yet.</td></tr>}
      </tbody>
    </table>
  </div>
</>}
        {/* Check-In */}
        {tab === 'check-in' && <>
          <h2 style={{ ...s.h2, marginBottom: 4 }}>Check-In</h2>
          <p style={{ color: '#666', fontSize: 14, marginBottom: 20 }}>Tablet-optimized · Touch-friendly</p>
          <div style={s.card}>
            <CheckInPanel token={token} evFilter={evFilter} />
          </div>
        </>}

       {tab === 'communications' && <CommunicationsTab token={token} evFilter={evFilter} />}
{tab === 'import' && <ImportTab token={token} />}

{tab === 'users' && <>
  <h2 style={{ ...s.h2, marginBottom: 16 }}>Admin Users</h2>
  <div style={{ ...s.card, display: 'flex', gap: 10, alignItems: 'flex-end', marginBottom: 20 }}>
    <div style={{ flex: 1 }}>
      <label style={s.label}>Email</label>
      <input style={s.input} type="email" value={newUserEmail} onChange={e => setNewUserEmail(e.target.value)} placeholder="person@example.com" />
    </div>
    <div style={{ flex: 1 }}>
      <label style={s.label}>Password</label>
      <input style={s.input} type="text" value={newUserPassword} onChange={e => setNewUserPassword(e.target.value)} placeholder="Choose a password" />
    </div>
    <button style={s.btnPrimary} onClick={addAdminUser} disabled={!newUserEmail.trim() || !newUserPassword.trim()}>+ Add User</button>
  </div>
  <div style={{ ...s.card, padding: 0, overflowX: 'auto' }}>
    <table>
      <thead><tr>{['Email', 'Created', ''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
      <tbody>
        {adminUsers.length ? adminUsers.map(u => (
          <tr key={u.id}>
            <td style={s.td}>{u.email}</td>
            <td style={s.td}>{new Date(u.created_at).toLocaleDateString()}</td>
            <td style={s.td}><button onClick={() => deleteAdminUser(u.id, u.email)} style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: 13 }}>Remove</button></td>
          </tr>
        )) : <tr><td colSpan={3} style={{ ...s.td, textAlign: 'center', color: '#999' }}>No additional admin users yet.</td></tr>}
      </tbody>
    </table>
  </div>
</>}
      </div>
{expandedVolunteer && (
  <VolunteerShiftEditor
    volunteer={expandedVolunteer}
    roleQuotas={roleQuotas}
    existingShifts={getShiftsFor(expandedVolunteer.id)}
    onSave={(assignments) => saveShiftsFor(expandedVolunteer.id, expandedVolunteer.event, assignments)}
    onClose={() => setExpandedVolunteer(null)}
  />
)}
      {editingRecord && (
        <EditRecordModal
          record={editingRecord.record}
          type={editingRecord.type}
          token={token}
          onClose={() => setEditingRecord(null)}
          onSaved={() => { editingRecord.type === 'athletes' ? loadAthletes() : loadVolunteers(); }}
        />
      )}
    </div>
  );
}

// ─── Check-In Panel ────────────────────────────────────────────────────────
function CheckInPanel({ token, evFilter }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [counts, setCounts] = useState({ checkedIn: 0, total: 0 });
  const [buddies, setBuddies] = useState([]);
  const h = { 'x-admin-token': token };

  useEffect(() => {
    fetch(`${API}/api/buddies?event=${evFilter}`, { headers: h })
      .then(r => r.ok ? r.json() : { buddies: [] })
      .then(d => setBuddies(d.buddies || []))
      .catch(() => {});
  }, [evFilter, token]);

  const assignBuddyAtCheckIn = async (athleteId, buddyId) => {
    await fetch(`${API}/api/buddies/assign`, { method: 'POST', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ athleteId, buddyId: buddyId || null, event: evFilter }) });
  };

  const search = async (q) => {
    setQuery(q);
    if (!q || q.length < 2) { setResults([]); return; }
    try {
      const [ar, vr] = await Promise.all([
        fetch(`${API}/api/athletes?event=${evFilter}`, { headers: h }).then(r => r.json()),
        fetch(`${API}/api/volunteers?event=${evFilter}`, { headers: h }).then(r => r.json()),
      ]);
      const all = [
        ...ar.map(x => ({ ...x, type: 'athlete' })),
        ...vr.map(x => ({ ...x, type: 'volunteer' })),
      ];
      setCounts({
        checkedIn: all.filter(x => x.status === 'Checked In').length,
        total: all.length,
      });
      setResults(all.filter(r => `${r.first_name} ${r.last_name} ${r.email}`.toLowerCase().includes(q.toLowerCase())));
    } catch {}
  };

  const checkIn = async (id, type) => {
    await fetch(`${API}/api/${type}s/${id}/status`, { method: 'PATCH', headers: { ...h, 'Content-Type': 'application/json' }, body: JSON.stringify({ status: 'Checked In' }) });
    setResults(prev => prev.map(r => r.id === id ? { ...r, status: 'Checked In' } : r));
    setCounts(prev => ({ ...prev, checkedIn: prev.checkedIn + 1 }));
  };

  return <>
    <input
      value={query}
      onChange={e => search(e.target.value)}
      placeholder="🔍  Search by name or email..."
      style={{ ...s.input, fontSize: 20, padding: '16px 20px', border: '2px solid #4fc3c3', borderRadius: 10, marginBottom: 20, textAlign: 'center' }}
    />
    {results.map(r => (
  <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 16, marginBottom: 10, background: r.status === 'Checked In' ? '#e8f9f9' : '#fff', border: `2px solid ${r.status === 'Checked In' ? '#4fc3c3' : '#eee'}`, borderRadius: 10, gap: 12 }}>
  <div style={{ flex: 1, minWidth: 0 }}>
    <div style={{ fontWeight: 800, fontSize: 20 }}>{r.first_name} {r.last_name}</div>
    <div style={{ fontSize: 13, color: '#666', marginTop: 2 }}>{r.type} · ATL–{r.event}{r.group_name ? ` · Group: ${r.group_name}` : ''}{r.assigned_role ? ` · ${r.assigned_role}` : ''}</div>
  </div>
  {r.type === 'athlete' && (
    <select
      defaultValue={r.buddy_id || ''}
      onChange={e => assignBuddyAtCheckIn(r.id, e.target.value)}
      style={{ fontSize: 12, padding: '5px 8px', border: '1px solid #ddd', borderRadius: 6, maxWidth: 140 }}
    >
      <option value="">Assign Buddy…</option>
      {buddies.map(b => <option key={b.id} value={b.id}>{b.first_name} {b.last_name}{b.buddy_color ? ` (${b.buddy_color})` : ''}</option>)}
    </select>
  )}
  {r.status === 'Checked In'
    ? <span style={{ fontSize: 28 }}>✅</span>
    : <button onClick={() => checkIn(r.id, r.type)} style={{ background: '#4fc3c3', color: '#1a1a1a', border: 'none', borderRadius: 8, padding: '16px 28px', fontWeight: 800, fontSize: 18, cursor: 'pointer', whiteSpace: 'nowrap' }}>CHECK IN</button>
  }
</div>
))}
    {query.length > 1 && results.length === 0 && <div style={{ textAlign: 'center', color: '#999', padding: 20 }}>No results found for "{query}"</div>}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginTop: 20 }}>
      {[['Checked In', counts.checkedIn, '#27ae60'], ['Expected', counts.total, '#1a1a1a'], ['Not Yet Arrived', counts.total - counts.checkedIn, '#e67e22']].map(([l, n, c]) => (
        <div key={l} style={s.statCard}><div style={{ fontSize: 36, fontWeight: 800, color: c }}>{n}</div><div style={{ fontSize: 13, color: '#666' }}>{l}</div></div>
      ))}
    </div>
  </>;
}

// ─── App Shell ─────────────────────────────────────────────────────────────
export default function App() {
  const [view, setView] = useState('home');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [adminToken, setAdminToken] = useState(null);

  const go = (v) => { setView(v); window.scrollTo(0, 0); };

  if (view === 'admin-login') return <AdminLogin onSuccess={t => { setAdminToken(t); go('admin'); }} />;
  if (view === 'admin' && adminToken) return <AdminDashboard token={adminToken} back={() => go('home')} />;
  if (view === 'athlete-select') return <EventSelect type="athlete" onSelect={k => { setSelectedEvent(k); go('athlete-form'); }} back={() => go('home')} />;
  if (view === 'volunteer-select') return <EventSelect type="volunteer" onSelect={k => { setSelectedEvent(k); go('volunteer-form'); }} back={() => go('home')} />;
  if (view === 'group-select') return <EventSelect type="group" onSelect={k => { setSelectedEvent(k); go('group-form'); }} back={() => go('home')} />;
  if (view === 'athlete-form' && selectedEvent) return <AthleteForm eventKey={selectedEvent} back={() => go('home')} />;
  if (view === 'volunteer-form' && selectedEvent) return <VolunteerForm eventKey={selectedEvent} back={() => go('volunteer-select')} />;
  if (view === 'group-form' && selectedEvent) return <GroupLeaderForm eventKey={selectedEvent} back={() => go('group-select')} />;
  if (view === 'waitlist-select') return <EventSelect type="waitlist" onSelect={k => { setSelectedEvent(k); go('waitlist-form'); }} back={() => go('home')} />;
  if (view === 'waitlist-form' && selectedEvent) return <WaitlistForm eventKey={selectedEvent} back={() => go('home')} />;

  return (
    <div style={s.app}>
      <div style={s.header}>
        <div><div style={s.logo}>AT THE LAKE</div><div style={s.logoSub}>Anthros Foundation</div></div>
        <div style={s.nav}>
          <button style={s.navBtn(view === 'home')} onClick={() => go('home')}>Home</button>
          <button style={s.navBtn(false)} onClick={() => go('athlete-select')}>Register as Athlete</button>
          <button style={s.navBtn(false)} onClick={() => go('volunteer-select')}>Register as Volunteer</button>
          <button style={s.navBtn(false)} onClick={() => go('group-select')}>Day Group Registration</button>
          <button style={s.navBtn(false)} onClick={() => go('admin-login')}>Admin</button>
        </div>
      </div>
      <Home go={go} />
    </div>
  );
}
